<template>
  <div>
    <div class="h-crumbOut">
      <div class="h-crumbs">
        <el-breadcrumb separator="|">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">项目管理</a></el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">盈利测算</a></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="h-piece">
      <div class="h-pieceTitle2">
        <h1>项目信息</h1>
      </div>
      <div class="h-pieceCon2">
        <div class="h-formLine h-enter">
          <el-form :model="ProMain" label-position="right" ref="formLabelAlign" :inline="true" class="demo-ruleForm h-formbLine" :rules="rules">
            <el-form-item label="项目名称" class="h-elformWrap-2">
              <el-input v-model="ProMain.projectName" placeholder="" disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="投标方式" class="h-elformWrap-2" prop="bidway">
              <brselect clearable category="cesuan_toubiao" :v="ProMain.bidway" v-model="ProMain.bidway" @change="toubiaochange" style="width: 100%"></brselect>
            </el-form-item>
            <el-form-item label="开标日期" class="h-elformWrap-2" prop="bid">
              <el-col :span="11">
                <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择时间" v-model="ProMain.bid" style="width: 2.6rem"></el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="保修期" class="h-elformWrap-2" prop="repairtype">
              <el-select v-model="repairtype" placeholder="请选择" @change="repairchangetype">
                <el-option v-for="item in repairOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="预付百分比%" class="h-elformWrap-2" prop="pdpay" v-if="!dailishangsuoding">
              <el-input v-model="ProMain.pdpay" placeholder="请输入.xxx" @blur="pdpaychange(ProMain.pdpay)" :disabled="dailishangsuoding">
              </el-input>
            </el-form-item>
            <el-form-item label="首款百分比%" class="h-elformWrap-2" prop="fdpay" v-if="!dailishangsuoding">
              <el-input v-model="ProMain.fdpay" placeholder="请输入.xxx" @blur="fdpaychange(ProMain.fdpay)" :disabled="dailishangsuoding">
              </el-input>
            </el-form-item>
            <el-form-item label="中款百分比%" class="h-elformWrap-2" prop="mdpay" v-if="!dailishangsuoding">
              <el-input v-model="ProMain.mdpay" placeholder="请输入.xxx" @blur="mdpaychange(ProMain.mdpay)" :disabled="dailishangsuoding" style="margin-right: 20px">
              </el-input>
            </el-form-item>
            <el-form-item label="尾款百分比%" class="h-elformWrap-2" prop="ldpay" v-if="!dailishangsuoding">
              <el-input v-model="ProMain.ldpay" placeholder="请输入.xxx" @blur="ldpaychange(ProMain.ldpay)" :disabled="dailishangsuoding">
              </el-input>
            </el-form-item>
            <el-form-item label="首款天" class="h-elformWrap-2" prop="fdpayday" v-if="!dailishangsuoding">
              <el-input v-model.number="ProMain.fdpayday" placeholder="请输入" oninput="value=value.replace(/[^\d]/g, '')" maxlength="3" :disabled="dailishangsuoding">
              </el-input>
            </el-form-item>
            <el-form-item label="中款天" class="h-elformWrap-2" prop="mdpayday" v-if="!dailishangsuoding">
              <el-input v-model.number="ProMain.mdpayday" placeholder="请输入" oninput="value=value.replace(/[^\d]/g, '')" maxlength="3" :disabled="dailishangsuoding">
              </el-input>
            </el-form-item>
            <el-form-item label="尾款天" class="h-elformWrap-2" prop="ldpayday" v-if="!dailishangsuoding">
              <el-input v-model.number="ProMain.ldpayday" placeholder="请输入" oninput="value=value.replace(/[^\d]/g, '')" maxlength="3" :disabled="dailishangsuoding">
              </el-input>
            </el-form-item>

            <el-form-item label="项目背景" class="h-elformWrap-2">
              <el-input v-model="ProMain.projectDescription" placeholder="" disabled="disabled"></el-input>
            </el-form-item>

            <el-form-item label="送达地址" class="h-elformWrap-2" prop="songdadizhi" :rules="[
                {
                  required: true,
                  message: '请选择送达地址',
                  trigger: 'change',
                },
              ]">
              <el-input clearable v-model="ProMain.songdadizhi" readonly>
                <i class="el-icon-search el-input__icon" slot="suffix" @click="selectAreadialog">
                </i>
              </el-input>
            </el-form-item>

            <el-form-item label="送达城市" class="h-elformWrap-2">
              <el-select v-model="ProMain.songdachengshi" placeholder="送达地址带出" filterable clearable disabled="disabled">
                <el-option v-for="(item, index) in songdachengshilist" :key="index" :label="`[${item.code}]${item.name}`" :value="item.code + '_' + item.name">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="终端成交" class="h-elformWrap-2">
              <el-input v-model="ProMain.zhongduanchengjiaojia" placeholder="" disabled="disabled"></el-input>
              <!--                            <el-select v-model="ProMain.zhongduanchengjiaojia" placeholder="请选择">-->
              <!--                                <el-option label="类型一" value="type1"></el-option>-->
              <!--                                <el-option label="类型二" value="type2"></el-option>-->
              <!--                            </el-select>-->
            </el-form-item>
            <el-form-item label="专营商毛利率" class="h-elformWrap-2">
              <el-input v-model="ProMain.zhuanyingshangmaolilv" placeholder="" disabled="disabled"></el-input>
            </el-form-item>

            <el-form-item label="选择特价使用人" class="h-elformWrap-2" style="position: relative" prop="xuanzhongren">
              <el-input v-model="ProMain.xuanzhongren" placeholder="请输入" readonly>
                <i class="el-icon-search el-input__icon" slot="suffix" @click="tanchuxuanzeren">
                </i>
              </el-input>
            </el-form-item>
            <el-form-item label="质保年限" class="h-elformWrap-2" prop="warrantyPeriod">
              <el-input v-model="ProMain.warrantyPeriod" placeholder="请输入质保年限" style="width: 1.9rem"></el-input>
              <span class="Z-yuan">年</span>
            </el-form-item>
            <el-form-item label="收货单位" class="h-elformWrap-2" prop="toCompanyname">
              <el-input v-model="ProMain.toCompanyname" placeholder="" disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="是否改制" class="h-elformWrap-2" prop="isReform">
              <el-select v-model="ProMain.isReform" disabled placeholder="请选择">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="改制附件" class="h-elformWrap-2">
              <brupload v-model="ProMain.gzFileUrl" :refid="this.proid" reftype="NXXM_GZFJ" :showtime="false" :limit="1">
              </brupload>
            </el-form-item>

            <showxuanzerencesuan :visible.sync="xuanzeren" v-if="xuanzeren" @choseObj="shiyongrenxuanze" oneflag title="选择经销商" />

            <el-form-item class="h-elformWrap-1 ljjrange" label="选择特价有效期" prop="youxiaoqi">
              <el-col>
                <!--                                <el-date-picker type="date" placeholder="选择时间" v-model="ProMain.youxiaoqi" value-format="yyyy-MM-dd"></el-date-picker>-->

                <el-date-picker v-model="ProMain.youxiaoqi" type="daterange" range-separator=" 至 " start-placeholder="开始日期" end-placeholder="结束日期" style="width: 6rem" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-col>
            </el-form-item>

            <el-form-item label="驳回审批意见" class="h-elformWrap-2" v-if="shenpiyijianshow">
              <el-input v-model="ProMain.shenpiyijian" placeholder="" disabled="disabled"></el-input>
            </el-form-item>

            <br />

            <el-form-item v-if="shenpiyijianshow" label="原始版本查看" class="h-elformWrap-2" prop="xiangmucode">
              <el-button type="text" size="small" class="h-tableLink h-btn" @click="cesuanbanbenchakan">原始版本查看
              </el-button>
            </el-form-item>

            <br />
          </el-form>
          <!--                    <div class="xia">-->
          <!--                        <el-button class="h-btn h-bBtn h-bgwhite" @click="qiehuanbanben" >切换计算版本</el-button>-->
          <!--                    </div>-->

          <div class="anniu" v-if="guanliyuan">
            <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="gongshiduizhaokai">公式对照表
            </el-button>
            <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="xiangxixinxixianshi">显示详细计算信息
            </el-button>
            <el-button class="el-button h-btn h-bBtn h-bgred el-button--default" @click="kankanyichang">
              异常信息
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-table ljjtableenterthree">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="产品" name="1">
          <el-table :data="tableData" :span-method="objectSpanMethod" @cell-dblclick="dblclick" border max-height="500" style="width: 100%" :row-class-name="tableRowClassName">
            <el-table-column prop="message" label="分类" width="140" :show-overflow-tooltip="true" fixed>
            </el-table-column>
            <el-table-column prop="coding" label="科目" fixed :show-overflow-tooltip="true" width="190">
            </el-table-column>
            <el-table-column prop="shuoming" label="说明" :show-overflow-tooltip="true" min-width="200">
            </el-table-column>
            <el-table-column prop="biaozhun" width="120" :show-overflow-tooltip="true" label="标准/单台">
            </el-table-column>
            <el-table-column prop="hejiL" width="140" :show-overflow-tooltip="true" label="合计-率">
              <template slot-scope="scope">
                <div v-if="scope.row.hejiL == '-'">{{ scope.row.hejiL }}</div>
                <div v-else-if="
                    scope.$index == 3 ||
                    scope.$index == 2 ||
                    scope.$index == 1 ||
                    scope.$index == 0
                  ">
                  {{ scope.row.hejiL }}
                </div>
                <div v-else :title="scope.row.hejiL">
                  {{
                    new big(Number(scope.row.hejiL || 0).toFixed(2)).times(
                      '100'
                    ) + '%'
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="hejiE" width="140" :show-overflow-tooltip="true" label="合计-额">
              <template slot-scope="scope">
                <div v-if="
                    scope.$index == 5 ||
                    scope.$index == 7 ||
                    scope.$index == 19 ||
                    scope.$index == 39 ||
                    scope.$index == 45
                  " :title="scope.row.hejiE">
                  {{
                    new big(Number(scope.row.hejiE || 0).toFixed(2)).times(
                      '100'
                    ) + '%'
                  }}
                </div>
                <div v-else-if="
                    scope.$index == 3 ||
                    scope.$index == 2 ||
                    scope.$index == 1 ||
                    scope.$index == 0
                  ">
                  {{ scope.row.hejiE }}
                </div>
                <div v-else :title="scope.row.hejiE">
                  {{ Number(scope.row.hejiE).toFixed(2) }}
                </div>
                <!-- <div v-if="scope.$index>3" :title="scope.row.hejiE">{{Math.round(scope.row.hejiE * 100) /
                            100}}
                        </div> -->
              </template>
            </el-table-column>
            <el-table-column min-width="150" :prop="item.prop" :label="item.label" v-for="item in columndata" :key="item.label">
              <!--						<template slot-scope="scope">-->
              <!--                            <div v-if="scope.row">{{scope.row[item.prop]}}</div>-->
              <!--							<el-input v-model="scope.row[item.prop]" v-else></el-input>-->
              <!--						</template>-->
              <template slot-scope="scope">
                <el-input class="h-tableInput" v-if="
                    scope.$index == 4 ||
                    scope.$index == 9 ||
                    scope.$index == 21 ||
                    scope.$index == 30
                  " v-model="scope.row[item.prop]"></el-input>
                <div v-else>
                  <div v-if="
                      scope.$index == 5 ||
                      scope.$index == 7 ||
                      scope.$index == 19 ||
                      scope.$index == 39 ||
                      scope.$index == 45
                    " :title="scope.row[item.prop]">
                    {{
                      new big(
                        Number(scope.row[item.prop] || 0).toFixed(2)
                      ).times('100') + '%'
                    }}
                  </div>
                  <div v-else-if="
                      scope.$index == 3 ||
                      scope.$index == 2 ||
                      scope.$index == 1 ||
                      scope.$index == 0
                    ">
                    {{ scope.row[item.prop] }}
                  </div>
                  <div v-else :title="scope.row[item.prop]">
                    {{ Number(scope.row[item.prop]).toFixed(2) }}
                  </div>
                  <!-- <div v-if="scope.$index > 3" :title="scope.row[item.prop]">
                                {{Math.round(scope.row[item.prop] * 100) / 100}}
                            </div>
                            <div v-else>{{scope.row[item.prop]}}</div> -->
                </div>
              </template>
            </el-table-column>
            <!--            <el-table-column-->
            <!--                    prop="xiugai"-->
            <!--                    label="修改"-->
            <!--            >-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div style="display:flex">-->
            <!--                        <el-select v-model="changeelse" placeholder="请选择" @change="elsechangetype">-->
            <!--                            <el-option v-for="item in changeelseOptions" :key="item.value"-->
            <!--                                       :label="item.label" :value="item.value">-->
            <!--                            </el-option>-->
            <!--                        </el-select>-->
            <!--                        <el-input v-model="scope.row.xiugai" placeholder="请输入"></el-input>-->
            <!--                        <el-button-->
            <!--                                type="text"-->
            <!--                                size="small"-->
            <!--                                class="h-tableLink"-->
            <!--                                @click="changetogo(scope.row.xiugai)">-->
            <!--                            修改-->
            <!--                        </el-button>-->
            <!--                    </div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
          </el-table>
          <div style="margin-top: 20px" v-if="
              xianshinage == 0 &&
              (this.caiwu || this.guanliyuan || this.caiwuShpFlag)
            ">
            <div class="yx_progressBar">
              <div class="yxExtra" style="right: 2.5rem; top: 0.4rem">
                <div style="margin-bottom: 0.2rem">该申请价格达到盈利目标</div>
              </div>
              <div class="yx_topTip">
                <div class="leftdes">
                  <span>材料毛利：</span><span class="percent">{{ zongmaolilv }}%</span>
                </div>
                <div class="leftdes">
                  <span>经营贡献：</span><span class="percent">{{
                    jingyinggongxiangzong != null &&
                    jingyinggongxiangzong != '' &&
                    jingyinggongxiangzong != 0
                      ? parseFloat(jingyinggongxiangzong).toFixed(2)
                      : 0
                  }}</span>
                </div>
                <div class="leftdes">
                  <span>经营贡献率：</span><span class="percent">{{
                      this.tableData && this.tableData.length > 0
                        ? this.tableData[39].hejiE == null ||
                          this.tableData[39].hejiE == ''
                          ? 0
                          : (
                              parseFloat(this.tableData[39].hejiE) * 100
                            ).toFixed(2)
                        : 0
                    }}%</span>
                </div>
                <div class="leftdes">
                  <span>利润：</span><span class="percent">{{
                    lirunzong != null && lirunzong != '' && lirunzong != 0
                      ? parseFloat(lirunzong).toFixed(2)
                      : 0
                  }}</span>
                </div>
                <div class="leftdes">
                  <span>利润率：</span><span class="percent">{{
                      this.tableData && this.tableData.length > 0
                        ? this.tableData[45].hejiE == null ||
                          this.tableData[45].hejiE == ''
                          ? 0
                          : (
                              parseFloat(this.tableData[45].hejiE) * 100
                            ).toFixed(2)
                        : 0
                    }}%</span>
                </div>
              </div>
              <!--            <div class="con_progress">-->
              <!--                <div class="eve_proout" v-for="(item,i) in progressBar" :key="i">-->
              <!--                    <div class="eve_pro">-->
              <!--                        <div class="persons">{{item.name}}</div>-->
              <!--                    </div>-->
              <!--                    <div class="line_pro"></div>-->
              <!--                </div>-->
              <!--            </div>-->
            </div>
          </div>
          <div style="margin-top: 20px" v-if="
              xianshinage == 1 &&
              (this.caiwu || this.guanliyuan || this.caiwuShpFlag)
            ">
            <div class="yx_progressBar yx_progressBarAc">
              <div class="yxExtra" style="right: 2.5rem; top: 0.4rem">
                <div style="margin-bottom: 0.2rem"></div>
              </div>
              <!--            <el-button class="h-btn h-bgblueQ2" @click="tijiaoshenqingtejia" style="position:absolute;top:0.3rem;right: 0.7rem">发起特价申请</el-button>-->
              <div class="yx_topTip">
                <div class="leftdes">
                  <span>材料毛利：</span><span class="percent">{{ zongmaolilv }}%</span>
                </div>
                <div class="leftdes">
                  <span>经营贡献：</span><span class="percent">{{
                    jingyinggongxiangzong != null &&
                    jingyinggongxiangzong != '' &&
                    jingyinggongxiangzong != 0
                      ? parseFloat(jingyinggongxiangzong).toFixed(2)
                      : 0
                  }}</span>
                </div>
                <div class="leftdes">
                  <span>经营贡献率：</span><span class="percent">{{
                      this.tableData && this.tableData.length > 0
                        ? this.tableData[39].hejiE == null ||
                          this.tableData[39].hejiE == ''
                          ? 0
                          : (
                              parseFloat(this.tableData[39].hejiE) * 100
                            ).toFixed(2)
                        : 0
                    }}%</span>
                </div>
                <div class="leftdes">
                  <span>利润：</span><span class="percent">{{
                    lirunzong != null && lirunzong != '' && lirunzong != 0
                      ? parseFloat(lirunzong).toFixed(2)
                      : 0
                  }}</span>
                </div>
                <div class="leftdes">
                  <span>利润率：</span><span class="percent">{{
                      this.tableData && this.tableData.length > 0
                        ? this.tableData[45].hejiE == null ||
                          this.tableData[45].hejiE == ''
                          ? 0
                          : (
                              parseFloat(this.tableData[45].hejiE) * 100
                            ).toFixed(2)
                        : 0
                    }}%</span>
                </div>
              </div>
              <!--            <div class="con_progress">-->
              <!--                <div class="eve_proout" v-for="(item,i) in progressBar" :key="i">-->
              <!--                    <div class="eve_pro" :class="{eve_proAc:item.ifBlue==1,eve_proAcpass:item.ifBlue ==2}">-->
              <!--                        <div class="persons" :class="{personsAc:item.ifBlue==1}">{{item.name}}</div>-->
              <!--                    </div>-->
              <!--                    <div class="line_pro" :class="{line_proAc:item.ifBlue==1,line_proAcpass:item.ifBlue == 2}"></div>-->
              <!--                </div>-->
              <!--            </div>-->
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="区域" name="2" v-if="regionChack">
          <el-table :data="regionData" :span-method="arraySpanMethod" @cell-dblclick="dblclick" border max-height="500" style="width: 100%" :row-class-name="tableRowClassName">
            <el-table-column prop="message" label="分类" min-width="80" :show-overflow-tooltip="true" fixed>
            </el-table-column>
            <el-table-column prop="coding" label="科目" fixed :show-overflow-tooltip="true" min-width="120">
            </el-table-column>
            <el-table-column prop="shuoming" label="说明" :show-overflow-tooltip="true" min-width="200">
            </el-table-column>
            <!-- <el-table-column
              prop="biaozhun"
              width="120"
              :show-overflow-tooltip="true"
              label="标准/单台"
            >
            </el-table-column> -->
            <el-table-column prop="hejiL" min-width="120" :show-overflow-tooltip="true" label="合计-率">
              <template slot-scope="scope">
                <div v-if="scope.row.hejiL == '-'">{{ scope.row.hejiL }}</div>
                <div v-else-if="
                    scope.$index == 1
                  ">
                  {{new big(Number(scope.row.hejiL || 0).toFixed(2)).times('100') + '%'}}
                </div>
                <div v-else :title="scope.row.hejiL">
                  {{new big(Number(scope.row.hejiL || 0)).times('100') + '%'}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="hejiE" min-width="120" :show-overflow-tooltip="true" label="合计-额">
              <template slot-scope="scope">
                <div v-if="scope.$index == 1||scope.$index == 9||scope.$index == 19" :title="scope.row.hejiE">
                  {{new big(Number(scope.row.hejiE || 0).toFixed(2)).times('100') + '%'}}
                </div>
                <div v-else :title="scope.row.hejiE">
                  {{ Number(scope.row.hejiE).toFixed(2) }}
                </div>
                <!-- <div v-if="scope.$index>3" :title="scope.row.hejiE">{{Math.round(scope.row.hejiE * 100) /
                            100}}
                        </div> -->
              </template>
            </el-table-column>
            <el-table-column min-width="120" :prop="item.prop" :label="item.label" v-for="item in columndata" :key="item.label">
              <!--						<template slot-scope="scope">-->
              <!--                            <div v-if="scope.row">{{scope.row[item.prop]}}</div>-->
              <!--							<el-input v-model="scope.row[item.prop]" v-else></el-input>-->
              <!--						</template>-->
              <template slot-scope="scope">
                <!-- <el-input class="h-tableInput" v-if="
                    scope.$index == 4 ||
                    scope.$index == 9 ||
                    scope.$index == 21 ||
                    scope.$index == 30
                  " v-model="scope.row[item.prop]"></el-input> -->
                <!-- <div v-else> -->
                <div v-if="
                      scope.$index == 1 ||
                      scope.$index == 9 ||
                      scope.$index == 19 
                    " :title="scope.row[item.prop]">
                  {{ new big(Number(scope.row[item.prop] || 0).toFixed(2)).times('100') + '%'}}
                </div>
                <div v-else :title="scope.row[item.prop]">
                  {{ Number(scope.row[item.prop]).toFixed(2) }}
                </div>
                <!-- </div> -->
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

      <!--            <div class="h-tableB h-mrt30" style="height: 1rem;">-->
      <!--                <div class="h-pagination2 ">-->
      <!--                    <paginationminNosize :page="q" @query="nextpage"/>-->
      <!--                </div>-->
      <!--            </div>-->
    </div>

    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />
    <div class="xia" style="margin-top: 0.3rem">
      <div class="xia" v-if="!shifouzhidu && !bohuitijiao" style="margin-top: 0.3rem">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="fanhuishangye">返回</el-button>
        <el-button class="h-btn h-bBtn h-bggreen" @click="getconfigs(2)">暂存</el-button>
        <el-button class="h-btn h-bBtn h-bggreen" @click="getconfigs(1)">计算
        </el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="getconfigs(3)">
          确认提交
        </el-button>
        <el-button class="h-btn h-bBtn h-bgred" @click="handleDelete">删除版本</el-button>
      </div>

      <div class="xia" v-if="bohuitijiao" style="margin-top: 0.3rem">
        <el-button class="h-btn h-bBtn h-bggreen" @click="getconfigs(1)">计算
        </el-button>
        <el-button class="h-btn h-bgblueQ2" @click="getconfigs(3)">
          重新提交
        </el-button>
      </div>
      <div class="xia" style="margin-top: 0.3rem">
        <el-button class="h-btn h-bBtn" @click="showhistory = true" style="margin-left: 0.1rem">
          跟踪审批
        </el-button>
      </div>
    </div>

    <!-- 选择以往测算版本 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="refuseDialog" class="h-dialog2" @close="gettable">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>选择以往测算版本</h1>
            <p>Selection process</p>
          </div>
        </div>
      </div>
      <div class="h-formLines">
        <div style="padding: 40px">
          <el-select v-model="banbenid" placeholder="请选择" style="width: 7rem" @change="fuzhi">
            <el-option v-for="item in banbenop" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <div style="text-align: right; margin-top: 5%">
            <el-button class="h-btn h-formBtn" style="" @click="refuseDialog = false">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 计算详细记录 -->
    <el-dialog :visible.sync="xiangxijilu" :show-close="true" :close-on-click-modal="false">
      <div>
        <el-input type="textarea" v-model="xiangxijilujieguo" readonly rows="50"></el-input>
      </div>

      <div style="text-align: right; margin-top: 5%">
        <el-button class="h-btn h-formBtn" style="" @click="xiangxijilu = false">确定</el-button>
      </div>
    </el-dialog>

    <!-- 公式对照表 -->
    <el-dialog :visible.sync="gongshiduizhao" :show-close="true" :close-on-click-modal="false">
      <div>
        <el-input type="textarea" v-model="gongshiduizhaobiao" readonly rows="50"></el-input>
      </div>

      <div style="text-align: right; margin-top: 5%">
        <el-button class="h-btn h-formBtn" style="" @click="gongshiduizhao = false">确定</el-button>
      </div>
    </el-dialog>

    <!-- 异常信息 -->
    <el-dialog :visible.sync="jianchayichang" :show-close="true" :close-on-click-modal="false">
      <div>
        <el-input type="textarea" v-model="yichangxinxi" readonly rows="50"></el-input>
      </div>

      <div style="text-align: right; margin-top: 5%">
        <el-button class="h-btn h-formBtn" style="" @click="jianchayichang = false">确定</el-button>
      </div>
    </el-dialog>

    <!--地址信息-->
    <areaSelect :visible.sync="showdizhiflag" v-if="showdizhiflag" @choseObj="choseDizhi" />
  </div>
</template>

<script>
import showxuanzerencesuan from '../../../components/dialog/selectshdfcesuan'
import ss from '../../../api/SystemService'
import big from 'big.js'

export default {
  components: {
    showxuanzerencesuan,
  },

  data () {
    return {
      activeName: '1',
      bohuitijiao: false,
      //只读版本id
      cesuanid: '',
      shifouzhidu: false,
      dailishangsuoding: false,
      shiyongrenuser: {},
      zhiqianbanben: {},
      meiyoubanben: false,
      yichangxinxi: '',
      jianchayichang: false,
      showdizhiflag: false,
      gongshiduizhaobiao: '',
      gongshiduizhao: false,
      guanliyuan: false,
      caiwu: false,
      caiwuShpFlag: false,
      xiangxijilu: false,
      xiangxijilujieguo: '',
      songdachengshilist: [],
      shifouxiaoshoujingli: false,
      xuanzeren: false,
      //驳回版本id
      delrversion: null,
      shenpiyijianshow: false,
      showhistory: false,
      instid: null,
      //前页项目
      qianyexiangmu: {},
      //选择项目参数
      rateFormulaRenewXiangmucanshu: null,
      //计算返回版本id
      fanhuibanbenid: null,
      //计算版本
      rversion: null,
      guochenglist: [],
      xuanzhongbanben: [],
      refuseDialog: false,
      banbenid: '',
      banbenop: [],
      //计算过程对象
      rateFormulaRenewVer: {},
      //显示哪个利率总计框
      xianshinage: 9,
      jingyinggongxiangzong: 0,
      lirunzong: 0,
      zongmaolilvbiao: 0,
      zongmaolilv: 0,
      // 进度
      progressBar: [
        { name: '王振刚', ifBlue: 1, ifing: 0 },
        { name: '总部管理员', ifBlue: 1, ifing: 0 },
        { name: '财务经理', ifBlue: 2, ifing: 0 },
        { name: '待审核', ifBlue: 0, ifing: 0 },
      ],
      list: [
        {
          title: '提交人:王振刚',
          isactive: 0,
          time: '2019/09/10 18:00:00',
        },
        {
          title: '总部管理员',
          isactive: 0,
          time: '2019/09/10 18:00:00',
        },
        {
          title: '待审核',
          isactive: 0,
          time: '2019/09/10 18:00:00',
        },
        {
          title: '财务经理',
          isactive: 0,
          time: '2019/09/10 18:00:00',
        },
      ],
      //物料号
      marcode: '',
      rules: {
        bidway: [{ required: true, message: '不能为空', trigger: 'blur' }],
        bid: [{ required: true, message: '不能为空', trigger: 'blur' }],
        repairtype: [{ required: true, message: '不能为空', trigger: 'blur' }],
        pdpay: [{ required: true, message: '不能为空', trigger: 'blur' }],
        fdpay: [{ required: true, message: '不能为空', trigger: 'blur' }],
        mdpay: [{ required: true, message: '不能为空', trigger: 'blur' }],
        ldpay: [{ required: true, message: '不能为空', trigger: 'blur' }],
        fdpayday: [{ required: true, message: '不能为空', trigger: 'blur' }],
        mdpayday: [{ required: true, message: '不能为空', trigger: 'blur' }],
        ldpayday: [{ required: true, message: '不能为空', trigger: 'blur' }],
        songdachengshi: [
          { required: true, message: '不能为空', trigger: 'blur' },
        ],
        songdadizhi: [{ required: true, message: '不能为空', trigger: 'blur' }],
        // xuanzhongren : [
        //     { required: true, message: '不能为空', trigger: 'blur' },
        // ],
        youxiaoqi: [{ required: true, message: '不能为空', trigger: 'blur' }],
      },
      //项目产品list
      xiangmuchanpinlist: [],
      q: {
        pageSize: 5,
        pageNo: 1,
        total: 0,
      },
      //全合计金额map
      allratemap: {},
      //是否首次交互
      shoucijiaohu: true,
      //申请单价含税 组
      shenqingdanjiaop: [],
      //附加成本 组
      fujiachengbenop: [],
      //附加成本
      fujiachengben: '',
      //申请单价含税
      shenqingdanjia: '',
      //项目编号
      proid: '',
      //质保选中值
      repairtype: '正常质保',
      repairOptions: [
        {
          value: '正常质保',
          label: '正常质保',
        },
        {
          value: '五年质保',
          label: '五年质保',
        },
      ],
      //
      columndata: [],
      //列表翻页参数
      value3: 0,
      //上部列表信息
      ProMain: {
        //选中人
        xuanzhongren: '',
        //使用人
        shiyongren: '',
        //有效期
        youxiaoqi: ['', ''],
        //送达地址
        songdadizhi: '',
        //送达城市
        songdachengshi: '',
        //项目名称
        projectName: '',
        //投标方式
        bidway: '',
        //开标日期
        bid: '',
        //预付百分比
        pdpay: '',
        //首款百分比
        fdpay: '',
        //中款百分比
        mdpay: '',
        //尾款百分比
        ldpay: '',
        //首款天
        fdpayday: '',
        //中款天
        mdpayday: '',
        //尾款天
        ldpayday: '',
        //项目描述
        projectDescription: '',
        //中标成交价
        zhongduanchengjiaojia: '',
        //专营商毛利率
        zhuanyingshangmaolilv: '',
        //审批意见
        shenpiyijian: '',
        warrantyPeriod: null,
        toCompanyname:null,
        isReform: null,
        gzFileUrl: null,
      },
      reformFlag: false,
      //当前表信息
      tableData: [],
      //所有查到的计算回调信息
      alllastlist: [],
      regionData: [],
      regionalFees: null,
      isCount: false,
      regionChack: false
    }
  },

  //加载页面默认执行
  created () {
    //管理员
    this.guanliyuan = this.$store.getters.hasRole('swyl_admin')

    //财务
    this.caiwu = this.$store.getters.hasRole('swyl_ylcs_caiwu')

    //加载公式表
    this.jiazaigongshibiao()

    //加载送达城市
    this.getsongdachengshilist()

    //判断目前使用人如果是销售经理，就会默认隐藏表格一部分
    for (var d in this._user.roles) {
      if (
        this._user.roles[d].id == 'swyl_xiaoshoujl' ||
        this._user.roles[d].id == 'swyl_xiaoshoujl_wx' ||
        this._user.roles[d].id == 'xiaoshoujingli-waixiao' ||
        this._user.roles[d].id == 'swyl_xiaoshoujl_honghu'
      ) {
        this.shifouxiaoshoujingli = true
      }
    }

    if (JSON.stringify(this.$route.query) != '{}') {
      // if (this.$route.query != null) {

      if (this.$route.query.ywid) {
        //ywid
        this.ywid = this.$route.query.ywid

        //instid
        this.instid = this.$route.query.instid

        //taskid
        this.taskid = this.$route.query.taskid

        //计算版本
        this.rversion = this.$route.query.ywid

        console.log(this.$route.query, 'eeeee???')

        this.caiwushenpi(this.instid)

        //默认首次交互
        this.getconfigs(0)
      } else if (this.$router.history.current.query.id) {
        //前页转发
        this.qianyezhuanfa()
      }
    }
  },

  mounted () { },

  methods: {
    //查找财务单保存
    chazhaocaiwudanbaocun (q) {
      ss.FormulaNew.finddanbaocun(q).then((rd) => {
        console.log(rd, 'rdrdrdrdoooooo')

        if (
          JSON.stringify(rd.obj) != '{}' &&
          rd.obj.rversion != null &&
          rd.obj.rversion != ''
        ) {
          this.cesuanid = rd.obj.rversion

          this.shenpiyijianshow = true
        }
      })
    },

    //测算版本查看
    cesuanbanbenchakan () {
      //测算版本有的话
      if (this.cesuanid != null && this.cesuanid != '') {
        var rversion = {
          rversion: this.cesuanid,
        }

        //查找测算版本
        ss.FormulaNew.getbanben(rversion).then((rd) => {
          console.log(rd.obj, '测算')

          //测算
          this.neiwaixiaopanduan(rd.obj)
        })
      }
    },

    //测算跳转判断
    neiwaixiaopanduan (q) {
      console.log(q, 'asdasd????')

      var path = ''

      if (q.neixiaowaixiao == 1 && q.ispro == 1) {
        //外销项目
        //跳转外销项目
        path = '/xiangmu/entersix'
      } else if (q.neixiaowaixiao == 1 && q.ispro == 0) {
        //外销工具
        //跳转外销工具
        path = '/xiangmu/enterseven'
      } else if (q.neixiaowaixiao == 0) {
        //内销
        //跳转内销测算
        path = '/xiangmu/enterfive'
      } else if (q.neixiaowaixiao == 2) {
        //租赁
        //跳转内销测算
        path = '/rateFormulaZulinshiti'
      }

      var shiti = {
        chakanshiti: q.rversion,
      }

      console.log(shiti, 'shitishitishiti')

      let routeData = this.$router.resolve({ path: path, query: shiti })
      window.open(routeData.href, '_blank')
    },

    qianyezhuanfa () {
      this.qianyexiangmu = this.$router.history.current.query

      console.log(this.$router.history.current.query)

      // //获取到前页转发的项目id
      // this.proid = this.$route.query.id;

      //this.q.projectId = this.$route.query.id;

      this.proid = this.$router.history.current.query.id
      this.q.projectId = this.$router.history.current.query.id
      console.log(this.q, '看看q')

      //查找版本
      this.chazhaocesuan(this.$router.history.current.query.id)

      //找项目使用人
      this.zhaodaoshiyongren(this.$router.history.current.query.id)

      //查找计算记录
      this.chazhaojisuanguocheng(this.$router.history.current.query.id)
    },

    toubiaochange (v) {
      if (v && v.code == '经销商') {
        console.log(v, 'v')

        this.ProMain.pdpay = 1
        this.ProMain.fdpay = 0
        this.ProMain.mdpay = 0
        this.ProMain.ldpay = 0
        this.ProMain.fdpayday = 0
        this.ProMain.mdpayday = 0
        this.ProMain.ldpayday = 0

        this.dailishangsuoding = true
      } else {
        this.ProMain.pdpay = ''
        this.ProMain.fdpay = ''
        this.ProMain.mdpay = ''
        this.ProMain.ldpay = ''
        this.ProMain.fdpayday = ''
        this.ProMain.mdpayday = ''
        this.ProMain.ldpayday = ''

        this.dailishangsuoding = false
      }
    },

    ldpaychange (v) {
      console.log(v)
      if (v == 0) {
        return
      } else {
        if (/^0.\d+$/.test(v) == false) {
          this.$msg.msge('请输入小于1的小数')
          this.ProMain.ldpay = ''
        } else {
          if (
            this.ProMain.ldpay &&
            this.ProMain.mdpay &&
            this.ProMain.fdpay &&
            this.ProMain.pdpay
          ) {
            if (
              parseFloat(this.ProMain.pdpay) +
              parseFloat(this.ProMain.fdpay) +
              parseFloat(this.ProMain.mdpay) +
              parseFloat(this.ProMain.ldpay) !=
              1
            ) {
              this.$msg.msge('四个百分值小数相加必须等于100%')
              this.ProMain.pdpay = ''
              this.ProMain.fdpay = ''
              this.ProMain.ldpay = ''
              this.ProMain.mdpay = ''
            } else {
              return
            }
          }
          console.log(v)
          return
        }
      }
    },
    mdpaychange (v) {
      console.log(v)
      if (v == 0) {
        return
      } else {
        if (/^0.\d+$/.test(v) == false) {
          this.$msg.msge('请输入小于1的小数')
          this.ProMain.mdpay = ''
        } else {
          if (
            this.ProMain.ldpay &&
            this.ProMain.mdpay &&
            this.ProMain.fdpay &&
            this.ProMain.pdpay
          ) {
            if (
              parseFloat(this.ProMain.pdpay) +
              parseFloat(this.ProMain.fdpay) +
              parseFloat(this.ProMain.mdpay) +
              parseFloat(this.ProMain.ldpay) !=
              1
            ) {
              this.$msg.msge('四个百分值小数相加必须等于100%')
              this.ProMain.pdpay = ''
              this.ProMain.fdpay = ''
              this.ProMain.ldpay = ''
              this.ProMain.mdpay = ''
            } else {
              return
            }
          }
          console.log(v)
          return
        }
      }
    },
    fdpaychange (v) {
      console.log(v)
      if (v == 0) {
        return
      } else {
        if (/^0.\d+$/.test(v) == false) {
          this.$msg.msge('请输入小于1的小数')
          this.ProMain.fdpay = ''
        } else {
          if (
            this.ProMain.ldpay &&
            this.ProMain.mdpay &&
            this.ProMain.fdpay &&
            this.ProMain.pdpay
          ) {
            if (
              parseFloat(this.ProMain.pdpay) +
              parseFloat(this.ProMain.fdpay) +
              parseFloat(this.ProMain.mdpay) +
              parseFloat(this.ProMain.ldpay) !=
              1
            ) {
              this.$msg.msge('四个百分值小数相加必须等于100%')
              this.ProMain.pdpay = ''
              this.ProMain.fdpay = ''
              this.ProMain.ldpay = ''
              this.ProMain.mdpay = ''
            } else {
              return
            }
          }
          console.log(v)
          return
        }
      }
    },
    pdpaychange (v) {
      console.log(v)
      if (v == 1) {
        this.ProMain.pdpay = 1
        this.ProMain.fdpay = 0
        this.ProMain.mdpay = 0
        this.ProMain.ldpay = 0
      } else {
        this.ProMain.fdpay = ''
        this.ProMain.mdpay = ''
        this.ProMain.ldpay = ''
        if (/^0.\d+$/.test(v) == false) {
          this.$msg.msge('请输入小于1的小数')
          this.ProMain.pdpay = ''
        } else {
          console.log(v)
          return
        }
      }
    },
    //找项目使用人
    zhaodaoshiyongren (q) {
      ss.FormulaNew.proMainselectById(q).then((rd) => {
        console.log(rd, 'rd')

        if (rd.obj == null || rd.obj.usercode == null) {
          this.$msg.msge('该项目信息缺少项目使用人')

          this.$router.push('/xiangmu/pm')
        }

        this.shiyongrenuser = rd.obj

        this.ProMain.xuanzhongren = rd.obj.username

        this.ProMain.shiyongren = rd.obj.usercode
      })
    },

    chazhaocesuan (q) {
      if (q != null && q != '') {
        var pid = {
          proid: q,
          neixiaowaixiao: 0,
        }

        ss.FormulaNew.findguocheng(pid).then((rd) => {
          console.log(rd, 'a')

          if (JSON.stringify(rd.obj) == '{}') {
            this.meiyoubanben = true
          } else {
            this.meiyoubanben = false

            this.zhiqianbanben = rd.obj
          }
        })
      } else {
        this.$msg.msge('缺少项目id')
      }
    },

    kankanyichang () {
      this.jianchayichang = true
    },

    //选择地址
    selectAreadialog () {
      this.showdizhiflag = true
    },

    choseDizhi (obj) {
      console.log(obj, 'objsss')

      console.log(obj.quobj.pscode + '_' + obj.quobj.name, 'o222ss')

      this.ProMain.songdachengshi = obj.quobj.pscode
        ? obj.quobj.pscode + '_' + obj.quobj.name
        : obj.shiobj.pscode
          ? obj.shiobj.pscode + '_' + obj.shiobj.name
          : null

      this.ProMain.songdadizhi = obj.quobj.namepath

      if (obj.zhenobj) {
        this.ProMain.songdadizhi = obj.zhenobj.namepath
      }

      this.ProMain.songdadizhi = this.ProMain.songdadizhi + obj.addrdetail

      // this.zy.province = obj.shengobj.name;
      // this.zy.city = obj.shiobj.name;
      // this.zy.country= obj.quobj.name;

      this.showdizhiflag = false
    },

    jiazaigongshibiao () {
      ss.FormulaNew.gongshibiaolist().then((rd1) => {
        this.gongshiduizhaobiao = ''

        for (var c in rd1) {
          if (rd1[c].type != 'w' && rd1[c].type != 'u') {
            this.gongshiduizhaobiao +=
              '公式名: ' +
              rd1[c].proName +
              (rd1[c].modelName != null && rd1[c].modelName != ''
                ? '/' + rd1[c].modelName
                : '') +
              (rd1[c].ratetext != null && rd1[c].ratetext != ''
                ? ' || 公式信息: ' + rd1[c].ratetext
                : '') +
              ' || 公式编号: ' +
              rd1[c].formulanum +
              (rd1[c].formula != null && rd1[c].formula != ''
                ? ' || 公式: ' + rd1[c].formula
                : '') +
              '\n' +
              '\n'
          }
        }
      })
    },

    gongshiduizhaokai () {
      this.gongshiduizhao = true
    },

    xiangxixinxixianshi () {
      this.xiangxijilu = true
    },

    jiazaijieguoxinxi (rd) {
      this.xiangxijilujieguo = ''

      this.yichangxinxi = ''

      for (var c in rd.jisuanjilu) {
        this.xiangxijilujieguo += c + rd.jisuanjilu[c] + '\n' + '\n'
      }

      this.yichangxinxi = rd.sb
    },

    //获取送达城市
    getsongdachengshilist () {
      ss.Dictservice.listbycategory('pscode_cesuan').then((rd) => {
        this.songdachengshilist = rd
      })
    },

    tableRowClassName (row, index) {
      //若是销售经理
      if (this.shifouxiaoshoujingli) {
        if (
          row.rowIndex != 0 &&
          row.rowIndex != 1 &&
          row.rowIndex != 2 &&
          row.rowIndex != 3 &&
          row.rowIndex != 4 &&
          row.rowIndex != 6 &&
          row.rowIndex != 8 &&
          row.rowIndex != 9 &&
          row.rowIndex != 11 &&
          row.rowIndex != 12 &&
          row.rowIndex != 21 &&
          row.rowIndex != 30
        ) {
          return 'hidden-row'
        }
        return ''
      }
    },

    //选择使用人
    shiyongrenxuanze (val) {
      console.log(val, '+++使用人')
      this.xuanzeren = false
      this.ProMain.xuanzhongren = val.username
      this.ProMain.shiyongren = val.usercode
    },

    tanchuxuanzeren () {
      this.xuanzeren = true
      // dialogFormVisible
    },

    qiehuanbanben () {
      if (this.meiyoubanben == true) {
        this.$msg.msge('没有测算版本')
      } else {
        this.shoucijiaohu = true
        this.banbenid = ''
        this.banbenop = []
        // this.chazhaojisuanguocheng(this.$router.history.current.query.id);
        this.chazhaojisuanguocheng('2019121309a91d84')
      }
    },

    //逻辑删除版本
    handleDelete () {
      if (this.rversion) {
        var id = {
          id: this.rversion,
        }

        ss.FormulaNew.luojishanchu(id).then((rd) => {
          this.$msg.msgs(rd.msg)

          this.qiehuanbanben()
        })
      } else {
        this.$msg.msge('未选择计算版本')
      }
    },

    //返回上页
    fanhuishangye () {
      //跳转
      this.$router.push('/xiangmu/pm')
    },

    //判断是否只读
    panduanshifouzhidu (q) {
      for (var d in q.obj) {
        //如果有不是暂存状态的历史版本，说明是只读页面
        if (
          q.obj[d].status != null &&
          q.obj[d].status != '' &&
          q.obj[d].status != 0
        ) {
          this.shifouzhidu = true
        }
      }

      console.log(this.shifouzhidu, 'this.shifouzhidu')
    },

    chazhaojisuanguocheng (q) {
      var pid = {
        proid: q,
        neixiaowaixiao: 0,
      }

      ss.FormulaNew.findguocheng(pid).then((rd) => {
        console.log(rd, 'rdrdrdrdrdrdrdrdrdrdrd')

        if (Object.keys(rd.obj).length === 0) {
          this.refuseDialog = false

          this.selelist()

          // this.query();
        } else {
          //判断只读
          this.panduanshifouzhidu(rd)

          //如果是只读
          if (this.shifouzhidu == true) {
            //只读加载版本
            this.zhidujiazaibanben(rd)
          } else {
            //正常加载版本
            this.zhengchangjiazaibanben(rd)
          }
        }
      })
    },

    //正常加载版本
    zhidujiazaibanben (rd) {
      var num = 0
      for (var i in rd.obj) {
        if (
          rd.obj[i].status != null &&
          rd.obj[i].status != '' &&
          rd.obj[i].status != 0
        ) {
          this.guochenglist.push(rd.obj[i])

          console.log(i, '反正--------')

          console.log(rd.obj[i], '---------反正')

          console.log(i, 'i.rversion')

          var d = {
            instid: rd.obj[i].instid,
            value: i,
            label:
              '版本 ' +
              (num + 1) +
              ' 创建时间:' +
              this.$util.riQi(rd.obj[i].cdate),
          }

          console.log(d, 'dddddd??')

          this.banbenop.push(d)

          num++
        }
      }

      this.refuseDialog = true
    },

    //正常加载版本
    zhengchangjiazaibanben (rd) {
      var num = 0
      for (var i in rd.obj) {
        this.guochenglist.push(rd.obj[i])

        console.log(i, '反正--------')

        console.log(rd.obj[i], '---------反正')

        console.log(i, 'i.rversion')

        var d = {
          instid: rd.obj[i].instid,
          value: i,
          label:
            '版本 ' +
            (num + 1) +
            ' 创建时间:' +
            this.$util.riQi(rd.obj[i].cdate),
        }

        console.log(d, 'dddddd??')

        this.banbenop.push(d)

        num++
      }

      this.refuseDialog = true
    },

    //关闭选择框加载数据
    gettable () {
      for (var d in this.banbenop) {
        if (this.banbenop[d].value == this.banbenid) {
          this.instid = this.banbenop[d].instid

          var rversion = this.banbenid

          if (this.instid == null || this.instid == '') {
            ss.FormulaNew.getOldRversion(this.banbenid).then((rd) => {
              if (rd.f) {
                this.instid = rd.msg
              }
            })
          }

          this.caiwushenpi(this.instid)

          console.log(this.banbenop, '看看')

          console.log(this.banbenop[d], '看看')

          console.log(this.banbenop[d].instid, '看看')
        }
      }

      this.caiwushenpi(this.instid)

      this.selelist()

      // this.query();
    },

    caiwushenpi (obj) {
      var data = {
        instid: '',
      }
      data.instid = obj

      ss.FormulaNew.searchNxCaiwuShpStatus(data).then((rd) => {
        if (rd.f) {
          this.caiwuShpFlag = true
        }
      })
    },

    //选没选值
    xuanmeixuanzhi (done) {
      this.$confirm('确认关闭？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then((_) => {
          if (!this.banbenid) {
            this.$msg.msge('请先选择')
            console.log('请先选择')
          } else {
            console.log(this.banbenid, '选中没')

            done()
          }
        })
        .catch((_) => { })
    },

    //选择，将被选中存起来
    fuzhi () {
      console.log(this.banbenid, '看看选择的对不对')

      //计算版本
      this.rversion = this.banbenid
    },

    //提交去申请特价
    tijiaoshenqingtejia () {
      console.log(this.proid, '看看项目号')

      //跳转特价页面
      this.$router.push({ path: '/pricenew', query: { proid: this.proid } })
    },

    con (i) {
      console.log(i)
    },
    getit () {
      return 1
    },
    dblclick (v, h, c, d) {
      console.log(v, h, c, d)
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        const _row = this.flitterData(this.regionData, 'coding', 'message').one[
          rowIndex
        ]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      } else if (columnIndex === 0) {
        const _row = this.flitterData(this.regionData, 'message', 'message')
          .one[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
    },
    flitterData (arr, evalua, name) {
      let spanOneArr = []
      let concatOne = 0
      arr.forEach((item, index) => {
        if (index === 0) {
          spanOneArr.push(1)
        } else {
          if (
            item[evalua] === arr[index - 1][evalua] &&
            item[name] === arr[index - 1][name]
          ) {
            //第一列需合并相同内容的判断条件
            spanOneArr[concatOne] += 1
            spanOneArr.push(0)
          } else {
            spanOneArr.push(1)
            concatOne = index
          }
        }
      })
      return {
        one: spanOneArr,
      }
    },
    // arraySpanMethod({ row, column, rowIndex, columnIndex }) {
    //   if (rowIndex % 3 === 0) {
    //     if (columnIndex === 0) {
    //       return [1, 4]
    //     } else if (columnIndex === 1) {
    //       return [0, 0]
    //     }
    //   }
    // },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      //不是销售经理
      if (this.shifouxiaoshoujingli == false) {
        if (columnIndex === 0) {
          if (rowIndex === 0) {
            return {
              rowspan: 6,
              colspan: 1,
            }
          } else if (rowIndex === 6) {
            // 当第7行就为正常的一行；要返回 把1行合并为一列
            return {
              rowspan: 7,
              colspan: 1,
            }
          } else if (rowIndex === 13) {
            return {
              rowspan: 3,
              colspan: 1,
            }
          } else if (rowIndex === 16) {
            return {
              rowspan: 4,
              colspan: 1,
            }
          } else if (rowIndex === 20) {
            return {
              rowspan: 18,
              colspan: 1,
            }
          } else if (rowIndex === 38) {
            return {
              rowspan: 2,
              colspan: 1,
            }
          } else if (rowIndex === 40) {
            return {
              rowspan: 4,
              colspan: 1,
            }
          } else if (rowIndex === 44) {
            return {
              rowspan: 2,
              colspan: 1,
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            }
          }
        }
        if (columnIndex === 1) {
          if (rowIndex === 22) {
            return {
              rowspan: 2,
              colspan: 1,
            }
          } else if (rowIndex === 23) {
            return {
              rowspan: 0,
              colspan: 0,
            }
          } else if (rowIndex === 24) {
            return {
              rowspan: 2,
              colspan: 1,
            }
          } else if (rowIndex === 25) {
            return {
              rowspan: 0,
              colspan: 0,
            }
          } else if (rowIndex === 31) {
            return {
              rowspan: 2,
              colspan: 1,
            }
          } else if (rowIndex === 32) {
            return {
              rowspan: 0,
              colspan: 0,
            }
          } else if (rowIndex === 33) {
            return {
              rowspan: 2,
              colspan: 1,
            }
          } else if (rowIndex === 34) {
            return {
              rowspan: 0,
              colspan: 0,
            }
          } else if (rowIndex === 35) {
            return {
              rowspan: 2,
              colspan: 1,
            }
          } else if (rowIndex === 36) {
            return {
              rowspan: 0,
              colspan: 0,
            }
          } else {
            return {
              rowspan: 1,
              colspan: 1,
            }
          }
        }
      } else {
        //销售经理

        if (columnIndex === 0) {
          if (rowIndex === 0) {
            return {
              rowspan: 5,
              colspan: 1,
            }
          } else if (rowIndex === 6) {
            return {
              rowspan: 5,
              colspan: 1,
            }
          } else if (rowIndex === 21) {
            return {
              rowspan: 1,
              colspan: 1,
            }
          } else if (rowIndex === 30) {
            return {
              rowspan: 1,
              colspan: 1,
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            }
          }
        }
      }
    },

    selelist () {
      ss.FormulaNew.selectList(this.q).then((rd) => {
        this.xiangmuchanpinlist = rd

        console.log(this.xiangmuchanpinlist, '看看查到多少项目产品')

        if (this.shoucijiaohu) {
          //默认首次交互
          this.getconfigs(0)
        }
      })
    },

    // //查询翻页
    // query() {
    //
    //     ss.FormulaNew.selectPage(this.q).then(rd => {
    //
    //         if (rd.f != null && rd.f == false) {
    //             this.$msg.msge(rd.msg)
    //
    //             //跳转
    //             this.$router.push("/personal/dealCenter");
    //
    //         }
    //
    //         this.q.total = rd.total;
    //
    //         this.xiangmuchanpinlist = rd.records;
    //
    //         console.log(this.xiangmuchanpinlist, '看看查到多少项目产品')
    //
    //
    //         if (this.shoucijiaohu) {
    //
    //             //默认首次交互
    //             this.getconfigs(0);
    //
    //         }
    //
    //     })
    //
    // },

    // handleFilter() {
    //     this.q.pageNo = 1;
    //     this.query();
    // },

    // rules: {
    //     name: [
    //         {required: true, message: '请输入项目名称', trigger: 'blur'},
    //     ],
    // },

    //保修期选择方法
    repairchangetype (value) {
      console.log(value)
      console.log(this.repairtype)
    },

    //加载列
    addbiaotilie (listrd, allrate, rateFormulaRenewAreaList) {
      this.columndata = []
      console.log(listrd)
      for (var c in listrd) {
        console.log(c)

        var cc = {
          prop: 'xinghao' + new big(parseInt(c)).plus(1).toString(),
          label: '型号' + new big(parseInt(c)).plus(1).toString(),
        }
        this.columndata.push(cc)
      }
      console.log(this.columndata, '表格数据')
      this.addshuju(listrd, allrate, rateFormulaRenewAreaList)
    },

    //加载列的数据
    addshuju (listrd, allrate, rateFormulaRenewAreaList) {
      this.alllastlist = []

      //单页数据
      var csave = {}

      //遍历每个产品的单表
      for (var c in listrd) {
        // console.log(listrd[c],"..........................")
        if (!this.isCount) {
          //单页数据
          csave = {
            //项目产品id
            proProductInfoId:
              listrd[c].proProductInfoId == null
                ? ''
                : listrd[c].proProductInfoId,
            //销量
            productNum:
              listrd[c].productNum == null
                ? ''
                : parseFloat(listrd[c].productNum).toString(),

            //产品编码
            marcode: listrd[c].marcode == null ? '' : listrd[c].marcode,

            //大类
            typeLevel: listrd[c].typeLevel == null ? '' : listrd[c].typeLevel,

            //系列
            opeLevel: listrd[c].opeLevel == null ? '' : listrd[c].opeLevel,

            //不知道是啥
            nonetypeLevel:
              listrd[c].nonetypeLevel == null ? '' : listrd[c].nonetypeLevel,

            //产品型号
            productLevel:
              listrd[c].productLevel == null ? '' : listrd[c].productLevel,

            //单台一级供价
            onemoney:
              listrd[c].onemoney == null
                ? ''
                : parseFloat(listrd[c].onemoney).toString(),

            //专营商毛利率
            zhuanyingshangmaolilv:
              listrd[c].zhuanyingshangmaolilv == null
                ? ''
                : parseFloat(listrd[c].zhuanyingshangmaolilv).toString(),

            //申请单价含税
            shenqingdanjia:
              listrd[c].shenqingdanjia == null
                ? ''
                : parseFloat(listrd[c].shenqingdanjia).toString(),

            //折扣率
            zhekoulv:
              listrd[c].zhekoulv == null
                ? ''
                : parseFloat(listrd[c].zhekoulv).toString(),

            //订单金额
            dingdanjine:
              listrd[c].dingdanjine == null
                ? ''
                : parseFloat(listrd[c].dingdanjine).toString(),

            //不含税订单收入
            buhanshuishouru:
              listrd[c].buhanshuishouru == null
                ? ''
                : parseFloat(listrd[c].buhanshuishouru).toString(),


            //单台成本
            dantaichengben:
              listrd[c].dantaichengben == null
                ? ''
                : parseFloat(listrd[c].dantaichengben).toString(),

            //制造费用
            zhizaofeiyong:
              listrd[c].zhizaofeiyong == null
                ? ''
                : parseFloat(listrd[c].zhizaofeiyong).toString(),

            //材料的制造费用率
            zhizaofeiyonglv:
              listrd[c].zhizaofeiyonglv == null
                ? ''
                : parseFloat(listrd[c].zhizaofeiyonglv).toString(),

            //单台体积
            wuliufeiyongdanweitiji:
              listrd[c].wuliufeiyongdanweitiji == null
                ? ''
                : parseFloat(listrd[c].wuliufeiyongdanweitiji).toString(),

            //单台安装费
            dantaianzhuangfei:
              listrd[c].dantaianzhuangfei == null
                ? ''
                : parseFloat(listrd[c].dantaianzhuangfei).toString(),

            //安装费
            anzhuangfeianzhuangfei:
              listrd[c].anzhuangfeianzhuangfei == null
                ? ''
                : parseFloat(listrd[c].anzhuangfeianzhuangfei).toString(),

            //维修基金
            weixiujijin:
              listrd[c].weixiujijin == null
                ? ''
                : parseFloat(listrd[c].weixiujijin).toString(),

            //盈亏平衡含税价
            yingkuipingheng:
              listrd[c].yingkuipingheng == null
                ? ''
                : parseFloat(listrd[c].yingkuipingheng).toString(),

            //材料毛利
            yinglicailiaomaoli:
              listrd[c].yinglicailiaomaoli == null
                ? ''
                : parseFloat(listrd[c].yinglicailiaomaoli).toString(),

            //经营贡献
            jingyinggongxian:
              listrd[c].jingyinggongxian == null
                ? ''
                : parseFloat(listrd[c].jingyinggongxian).toString(),

            //盈利 利润
            yinglilirun:
              listrd[c].yinglilirun == null
                ? ''
                : parseFloat(listrd[c].yinglilirun).toString(),

            //毛利 成本合计
            maolichengbenheji:
              listrd[c].maolichengbenheji == null
                ? ''
                : parseFloat(listrd[c].maolichengbenheji).toString(),

            //毛利 毛利
            maolimaoli:
              listrd[c].maolimaoli == null
                ? ''
                : parseFloat(listrd[c].maolimaoli).toString(),

            //毛利 材料毛利率
            maolimaolilv:
              listrd[c].maolimaolilv == null
                ? ''
                : parseFloat(listrd[c].maolimaolilv).toString(),

            //直接费用 物流费用 运费
            wuliufeiyongyunfei:
              listrd[c].wuliufeiyongyunfei == null
                ? ''
                : parseFloat(listrd[c].wuliufeiyongyunfei).toString(),

            //直接费用 维修费  18年到产品实际费用
            zhijiefeiyongweixiufei:
              listrd[c].zhijiefeiyongweixiufei == null
                ? ''
                : parseFloat(listrd[c].zhijiefeiyongweixiufei).toString(),

            //直接费用 备件费 18年到产品实际费用
            zhijiefeiyongbeijianfei:
              listrd[c].zhijiefeiyongbeijianfei == null
                ? ''
                : parseFloat(listrd[c].zhijiefeiyongbeijianfei).toString(),

            //直接费用 退换机 18年到产品实际费用
            zhijiefeiyongtuihuanjifei:
              listrd[c].zhijiefeiyongtuihuanjifei == null
                ? ''
                : parseFloat(listrd[c].zhijiefeiyongtuihuanjifei).toString(),

            //直接费用 退换机 18年到产品实际费用
            zijinchengben:
              listrd[c].zijinchengben == null
                ? ''
                : parseFloat(listrd[c].zijinchengben).toString(),
            //中标服务费
            zhongbiaofuwufei:
              listrd[c].zhongbiaofuwufei == null
                ? ''
                : parseFloat(listrd[c].zhongbiaofuwufei).toString(),

            //直接费用 税费 其他税费
            shuifeiqitashuifei:
              listrd[c].shuifeiqitashuifei == null
                ? ''
                : parseFloat(listrd[c].shuifeiqitashuifei).toString(),
            //销售费用 销售人工
            xiaoshoufeiyongrengong:
              listrd[c].xiaoshoufeiyongrengong == null
                ? ''
                : parseFloat(listrd[c].xiaoshoufeiyongrengong).toString(),
            //销售费用 销售组织运营
            xiaoshouzuzhiyunying:
              listrd[c].xiaoshouzuzhiyunying == null
                ? ''
                : parseFloat(listrd[c].xiaoshouzuzhiyunying).toString(),
            //研发费用 研发人工
            yanfarengong:
              listrd[c].yanfarengong == null
                ? ''
                : parseFloat(listrd[c].yanfarengong).toString(),
            //研发费用 研发组织运营
            yanfayunying:
              listrd[c].yanfayunying == null
                ? ''
                : parseFloat(listrd[c].yanfayunying).toString(),
            //直接费用小计
            zhijiefeiyongxiaoji:
              listrd[c].zhijiefeiyongxiaoji == null
                ? ''
                : parseFloat(listrd[c].zhijiefeiyongxiaoji).toString(),
            //经营贡献 经营贡献 经营贡献
            jingyinggongxiansan:
              listrd[c].jingyinggongxiansan == null
                ? ''
                : parseFloat(listrd[c].jingyinggongxiansan).toString(),
            //经营贡献 经营贡献率 经营贡献率
            jingyinggongxianlv:
              listrd[c].jingyinggongxianlv == null
                ? ''
                : parseFloat(listrd[c].jingyinggongxianlv).toString(),
            //平台费用 销售费用 自产费用率
            pingtaixiaoshoufeiyong:
              listrd[c].pingtaixiaoshoufeiyong == null
                ? ''
                : parseFloat(listrd[c].pingtaixiaoshoufeiyong).toString(),
            //平台费用 管理费用 全部产品费用率
            pingtaiguanlifeiyong:
              listrd[c].pingtaiguanlifeiyong == null
                ? ''
                : parseFloat(listrd[c].pingtaiguanlifeiyong).toString(),
            //平台费用 研发费用 自产研发费
            pingtaiyanfafeiyong:
              listrd[c].pingtaiyanfafeiyong == null
                ? ''
                : parseFloat(listrd[c].pingtaiyanfafeiyong).toString(),
            //平台费用 平台费用小计
            pingtaifeiyongxiaoji:
              listrd[c].pingtaifeiyongxiaoji == null
                ? ''
                : parseFloat(listrd[c].pingtaifeiyongxiaoji).toString(),
            //利润 利润  利润
            lirunsan:
              listrd[c].lirunsan == null
                ? ''
                : parseFloat(listrd[c].lirunsan).toString(),
            //利润 利润率  利润率
            lirunlirunlv:
              listrd[c].lirunlirunlv == null
                ? ''
                : parseFloat(listrd[c].lirunlirunlv).toString(),
            //附加成本  赠送耗材、周转机等成本 前台输入
            fujiachengben:
              listrd[c].fujiachengben == null
                ? ''
                : parseFloat(listrd[c].fujiachengben).toString(),
            //中标成交价
            zhongduanchengjiaojia:
              listrd[c].zhongduanchengjiaojia == null
                ? ''
                : parseFloat(listrd[c].zhongduanchengjiaojia).toString(),
            //损益表材料毛利率
            sunyibiaocailiaomaolilv:
              listrd[c].sunyibiaocailiaomaolilv == null
                ? ''
                : parseFloat(listrd[c].sunyibiaocailiaomaolilv).toString(),

            // --------------区域新增-LXT-------------------------
            //人工成本
            rengongchengben: !rateFormulaRenewAreaList || rateFormulaRenewAreaList.length == 0 ? listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.rengongchengben : 0)).toFixed(2).toString() : rateFormulaRenewAreaList[c].rengongchengben,
            //组织运营费
            zuzhiyunyingfei: !rateFormulaRenewAreaList || rateFormulaRenewAreaList.length == 0 ? listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.zuzhiyunyingfei : 0)).toFixed(2).toString() : rateFormulaRenewAreaList[c].zuzhiyunyingfei,
            //营销费用
            yingxiaofei: !rateFormulaRenewAreaList || rateFormulaRenewAreaList.length == 0 ? listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.yingxiaofei : 0)).toFixed(2).toString() : rateFormulaRenewAreaList[c].yingxiaofei,
            //物流费用
            wuliufei: !rateFormulaRenewAreaList || rateFormulaRenewAreaList.length == 0 ? listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.wuliufei : 0)).toFixed(2).toString() : rateFormulaRenewAreaList[c].wuliufei,
            //售后费用
            shouhoufei: !rateFormulaRenewAreaList || rateFormulaRenewAreaList.length == 0 ? listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.shouhoufei : 0)).toFixed(2).toString() : rateFormulaRenewAreaList[c].shouhoufei,
            //税费
            shuifei: !rateFormulaRenewAreaList || rateFormulaRenewAreaList.length == 0 ? listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.shuifei : 0)).toFixed(2).toString() : rateFormulaRenewAreaList[c].shuifei,
            //资产减值损失
            zichanjianzhisunshi: !rateFormulaRenewAreaList || rateFormulaRenewAreaList.length == 0 ? listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.zichanjianzhisunshi : 0)).toFixed(2).toString() : rateFormulaRenewAreaList[c].zichanjianzhisunshi,
          }
        } else {
          //单页数据
          csave = {
            //项目产品id
            proProductInfoId:
              listrd[c].proProductInfoId == null
                ? ''
                : listrd[c].proProductInfoId,
            //销量
            productNum:
              listrd[c].productNum == null
                ? ''
                : parseFloat(listrd[c].productNum).toString(),

            //产品编码
            marcode: listrd[c].marcode == null ? '' : listrd[c].marcode,

            //大类
            typeLevel: listrd[c].typeLevel == null ? '' : listrd[c].typeLevel,

            //系列
            opeLevel: listrd[c].opeLevel == null ? '' : listrd[c].opeLevel,

            //不知道是啥
            nonetypeLevel:
              listrd[c].nonetypeLevel == null ? '' : listrd[c].nonetypeLevel,

            //产品型号
            productLevel:
              listrd[c].productLevel == null ? '' : listrd[c].productLevel,

            //单台一级供价
            onemoney:
              listrd[c].onemoney == null
                ? ''
                : parseFloat(listrd[c].onemoney).toString(),

            //专营商毛利率
            zhuanyingshangmaolilv:
              listrd[c].zhuanyingshangmaolilv == null
                ? ''
                : parseFloat(listrd[c].zhuanyingshangmaolilv).toString(),

            //申请单价含税
            shenqingdanjia:
              listrd[c].shenqingdanjia == null
                ? ''
                : parseFloat(listrd[c].shenqingdanjia).toString(),

            //折扣率
            zhekoulv:
              listrd[c].zhekoulv == null
                ? ''
                : parseFloat(listrd[c].zhekoulv).toString(),

            //订单金额
            dingdanjine:
              listrd[c].dingdanjine == null
                ? ''
                : parseFloat(listrd[c].dingdanjine).toString(),

            //不含税订单收入
            buhanshuishouru:
              listrd[c].buhanshuishouru == null
                ? ''
                : parseFloat(listrd[c].buhanshuishouru).toString(),


            //单台成本
            dantaichengben:
              listrd[c].dantaichengben == null
                ? ''
                : parseFloat(listrd[c].dantaichengben).toString(),

            //制造费用
            zhizaofeiyong:
              listrd[c].zhizaofeiyong == null
                ? ''
                : parseFloat(listrd[c].zhizaofeiyong).toString(),

            //材料的制造费用率
            zhizaofeiyonglv:
              listrd[c].zhizaofeiyonglv == null
                ? ''
                : parseFloat(listrd[c].zhizaofeiyonglv).toString(),

            //单台体积
            wuliufeiyongdanweitiji:
              listrd[c].wuliufeiyongdanweitiji == null
                ? ''
                : parseFloat(listrd[c].wuliufeiyongdanweitiji).toString(),

            //单台安装费
            dantaianzhuangfei:
              listrd[c].dantaianzhuangfei == null
                ? ''
                : parseFloat(listrd[c].dantaianzhuangfei).toString(),

            //安装费
            anzhuangfeianzhuangfei:
              listrd[c].anzhuangfeianzhuangfei == null
                ? ''
                : parseFloat(listrd[c].anzhuangfeianzhuangfei).toString(),

            //维修基金
            weixiujijin:
              listrd[c].weixiujijin == null
                ? ''
                : parseFloat(listrd[c].weixiujijin).toString(),

            //盈亏平衡含税价
            yingkuipingheng:
              listrd[c].yingkuipingheng == null
                ? ''
                : parseFloat(listrd[c].yingkuipingheng).toString(),

            //材料毛利
            yinglicailiaomaoli:
              listrd[c].yinglicailiaomaoli == null
                ? ''
                : parseFloat(listrd[c].yinglicailiaomaoli).toString(),

            //经营贡献
            jingyinggongxian:
              listrd[c].jingyinggongxian == null
                ? ''
                : parseFloat(listrd[c].jingyinggongxian).toString(),

            //盈利 利润
            yinglilirun:
              listrd[c].yinglilirun == null
                ? ''
                : parseFloat(listrd[c].yinglilirun).toString(),

            //毛利 成本合计
            maolichengbenheji:
              listrd[c].maolichengbenheji == null
                ? ''
                : parseFloat(listrd[c].maolichengbenheji).toString(),

            //毛利 毛利
            maolimaoli:
              listrd[c].maolimaoli == null
                ? ''
                : parseFloat(listrd[c].maolimaoli).toString(),

            //毛利 材料毛利率
            maolimaolilv:
              listrd[c].maolimaolilv == null
                ? ''
                : parseFloat(listrd[c].maolimaolilv).toString(),

            //直接费用 物流费用 运费
            wuliufeiyongyunfei:
              listrd[c].wuliufeiyongyunfei == null
                ? ''
                : parseFloat(listrd[c].wuliufeiyongyunfei).toString(),

            //直接费用 维修费  18年到产品实际费用
            zhijiefeiyongweixiufei:
              listrd[c].zhijiefeiyongweixiufei == null
                ? ''
                : parseFloat(listrd[c].zhijiefeiyongweixiufei).toString(),

            //直接费用 备件费 18年到产品实际费用
            zhijiefeiyongbeijianfei:
              listrd[c].zhijiefeiyongbeijianfei == null
                ? ''
                : parseFloat(listrd[c].zhijiefeiyongbeijianfei).toString(),

            //直接费用 退换机 18年到产品实际费用
            zhijiefeiyongtuihuanjifei:
              listrd[c].zhijiefeiyongtuihuanjifei == null
                ? ''
                : parseFloat(listrd[c].zhijiefeiyongtuihuanjifei).toString(),

            //直接费用 退换机 18年到产品实际费用
            zijinchengben:
              listrd[c].zijinchengben == null
                ? ''
                : parseFloat(listrd[c].zijinchengben).toString(),
            //中标服务费
            zhongbiaofuwufei:
              listrd[c].zhongbiaofuwufei == null
                ? ''
                : parseFloat(listrd[c].zhongbiaofuwufei).toString(),

            //直接费用 税费 其他税费
            shuifeiqitashuifei:
              listrd[c].shuifeiqitashuifei == null
                ? ''
                : parseFloat(listrd[c].shuifeiqitashuifei).toString(),
            //销售费用 销售人工
            xiaoshoufeiyongrengong:
              listrd[c].xiaoshoufeiyongrengong == null
                ? ''
                : parseFloat(listrd[c].xiaoshoufeiyongrengong).toString(),
            //销售费用 销售组织运营
            xiaoshouzuzhiyunying:
              listrd[c].xiaoshouzuzhiyunying == null
                ? ''
                : parseFloat(listrd[c].xiaoshouzuzhiyunying).toString(),
            //研发费用 研发人工
            yanfarengong:
              listrd[c].yanfarengong == null
                ? ''
                : parseFloat(listrd[c].yanfarengong).toString(),
            //研发费用 研发组织运营
            yanfayunying:
              listrd[c].yanfayunying == null
                ? ''
                : parseFloat(listrd[c].yanfayunying).toString(),
            //直接费用小计
            zhijiefeiyongxiaoji:
              listrd[c].zhijiefeiyongxiaoji == null
                ? ''
                : parseFloat(listrd[c].zhijiefeiyongxiaoji).toString(),
            //经营贡献 经营贡献 经营贡献
            jingyinggongxiansan:
              listrd[c].jingyinggongxiansan == null
                ? ''
                : parseFloat(listrd[c].jingyinggongxiansan).toString(),
            //经营贡献 经营贡献率 经营贡献率
            jingyinggongxianlv:
              listrd[c].jingyinggongxianlv == null
                ? ''
                : parseFloat(listrd[c].jingyinggongxianlv).toString(),
            //平台费用 销售费用 自产费用率
            pingtaixiaoshoufeiyong:
              listrd[c].pingtaixiaoshoufeiyong == null
                ? ''
                : parseFloat(listrd[c].pingtaixiaoshoufeiyong).toString(),
            //平台费用 管理费用 全部产品费用率
            pingtaiguanlifeiyong:
              listrd[c].pingtaiguanlifeiyong == null
                ? ''
                : parseFloat(listrd[c].pingtaiguanlifeiyong).toString(),
            //平台费用 研发费用 自产研发费
            pingtaiyanfafeiyong:
              listrd[c].pingtaiyanfafeiyong == null
                ? ''
                : parseFloat(listrd[c].pingtaiyanfafeiyong).toString(),
            //平台费用 平台费用小计
            pingtaifeiyongxiaoji:
              listrd[c].pingtaifeiyongxiaoji == null
                ? ''
                : parseFloat(listrd[c].pingtaifeiyongxiaoji).toString(),
            //利润 利润  利润
            lirunsan:
              listrd[c].lirunsan == null
                ? ''
                : parseFloat(listrd[c].lirunsan).toString(),
            //利润 利润率  利润率
            lirunlirunlv:
              listrd[c].lirunlirunlv == null
                ? ''
                : parseFloat(listrd[c].lirunlirunlv).toString(),
            //附加成本  赠送耗材、周转机等成本 前台输入
            fujiachengben:
              listrd[c].fujiachengben == null
                ? ''
                : parseFloat(listrd[c].fujiachengben).toString(),
            //中标成交价
            zhongduanchengjiaojia:
              listrd[c].zhongduanchengjiaojia == null
                ? ''
                : parseFloat(listrd[c].zhongduanchengjiaojia).toString(),
            //损益表材料毛利率
            sunyibiaocailiaomaolilv:
              listrd[c].sunyibiaocailiaomaolilv == null
                ? ''
                : parseFloat(listrd[c].sunyibiaocailiaomaolilv).toString(),

            // --------------区域新增-LXT-------------------------
            //人工成本
            rengongchengben: listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.rengongchengben : 0)).toFixed(2).toString(),
            //组织运营费
            zuzhiyunyingfei: listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.zuzhiyunyingfei : 0)).toFixed(2).toString(),
            //营销费用
            yingxiaofei: listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.yingxiaofei : 0)).toFixed(2).toString(),
            //物流费用
            wuliufei: listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.wuliufei : 0)).toFixed(2).toString(),
            //售后费用
            shouhoufei: listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.shouhoufei : 0)).toFixed(2).toString(),
            //税费
            shuifei: listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.shuifei : 0)).toFixed(2).toString(),
            //资产减值损失
            zichanjianzhisunshi: listrd[c].buhanshuishouru == null
              ? ''
              : new big(parseFloat(listrd[c].buhanshuishouru)).times(parseFloat(this.regionalFees ? this.regionalFees.zichanjianzhisunshi : 0)).toFixed(2).toString(),
          }
        }


        this.alllastlist.push(csave)
      }


      this.tableData = [
        {
          message: '基本信息',
          coding: '编码',
          shuoming: '-',
          biaozhun: '-',
          hejiL: '-',
          hejiE: '-',
          xinghao1: this.alllastlist[0].marcode || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].marcode,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].marcode,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].marcode,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].marcode,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].marcode,
          id1: this.alllastlist[0].proProductInfoId || '',
          id2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].proProductInfoId,
          id3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].proProductInfoId,
          id4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].proProductInfoId,
          id5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].proProductInfoId,
          id6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].proProductInfoId,
          id7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].proProductInfoId,
          id8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].proProductInfoId,
          id9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].proProductInfoId,
          id10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].proProductInfoId,
          id11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].proProductInfoId,
          id12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].proProductInfoId,
          id13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].proProductInfoId,
          id14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].proProductInfoId,
          id15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].proProductInfoId,
          id16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].proProductInfoId,
          id17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].proProductInfoId,
          id18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].proProductInfoId,
          id19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].proProductInfoId,
          id20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].proProductInfoId,
          //0
        },
        {
          coding: '型号',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: '-',
          xinghao1: this.alllastlist[0].productLevel || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].productLevel,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].productLevel,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].productLevel,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].productLevel,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].productLevel,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].productLevel,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].productLevel,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].productLevel,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].productLevel,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].productLevel,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].productLevel,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].productLevel,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].productLevel,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].productLevel,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].productLevel,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].productLevel,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].productLevel,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].productLevel,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].productLevel,
          //1
        },
        {
          coding: '产品大类',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: '-',
          xinghao1: this.alllastlist[0].typeLevel || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].typeLevel,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].typeLevel,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].typeLevel,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].typeLevel,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].typeLevel,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].typeLevel,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].typeLevel,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].typeLevel,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].typeLevel,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].typeLevel,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].typeLevel,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].typeLevel,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].typeLevel,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].typeLevel,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].typeLevel,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].typeLevel,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].typeLevel,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].typeLevel,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].typeLevel,
          //2
        },
        {
          coding: '产品系列',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: '-',
          xinghao1: this.alllastlist[0].opeLevel || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].opeLevel,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].opeLevel,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].opeLevel,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].opeLevel,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].opeLevel,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].opeLevel,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].opeLevel,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].opeLevel,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].opeLevel,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].opeLevel,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].opeLevel,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].opeLevel,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].opeLevel,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].opeLevel,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].opeLevel,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].opeLevel,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].opeLevel,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].opeLevel,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].opeLevel,
          //3
        },
        {
          coding: '中标成交价',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.zhongduanchengjiaojia || '',
          canshu: 'zhongduanchengjiaojia',
          xinghao1: this.alllastlist[0].zhongduanchengjiaojia || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].zhongduanchengjiaojia,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].zhongduanchengjiaojia,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].zhongduanchengjiaojia,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].zhongduanchengjiaojia,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].zhongduanchengjiaojia,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].zhongduanchengjiaojia,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].zhongduanchengjiaojia,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].zhongduanchengjiaojia,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].zhongduanchengjiaojia,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].zhongduanchengjiaojia,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].zhongduanchengjiaojia,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].zhongduanchengjiaojia,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].zhongduanchengjiaojia,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].zhongduanchengjiaojia,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].zhongduanchengjiaojia,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].zhongduanchengjiaojia,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].zhongduanchengjiaojia,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].zhongduanchengjiaojia,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].zhongduanchengjiaojia,
          marcode1: this.alllastlist[0].marcode || '',
          marcode2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
          marcode3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
          marcode4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
          marcode5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
          marcode6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
          marcode7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
          marcode8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
          marcode9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
          marcode10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
          marcode11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
          marcode12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
          marcode13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
          marcode14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
          marcode15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
          marcode16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].marcode,
          marcode17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].marcode,
          marcode18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].marcode,
          marcode19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].marcode,
          marcode20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].marcode,
          canshuxulie: 'zhongduanchengjiaojia',
          //4
        },
        {
          coding: '专营商毛利率',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.zhuanyingshangmaolilv || '',
          xinghao1: this.alllastlist[0].zhuanyingshangmaolilv || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].zhuanyingshangmaolilv,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].zhuanyingshangmaolilv,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].zhuanyingshangmaolilv,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].zhuanyingshangmaolilv,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].zhuanyingshangmaolilv,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].zhuanyingshangmaolilv,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].zhuanyingshangmaolilv,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].zhuanyingshangmaolilv,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].zhuanyingshangmaolilv,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].zhuanyingshangmaolilv,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].zhuanyingshangmaolilv,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].zhuanyingshangmaolilv,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].zhuanyingshangmaolilv,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].zhuanyingshangmaolilv,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].zhuanyingshangmaolilv,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].zhuanyingshangmaolilv,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].zhuanyingshangmaolilv,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].zhuanyingshangmaolilv,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].zhuanyingshangmaolilv,
          canshuxulie: 'zhuanyingshangmaolilv',
          //5
        },

        {
          message: '收入',
          coding: '单台一级供价',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.onemoney || '',
          xinghao1: this.alllastlist[0].onemoney || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].onemoney,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].onemoney,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].onemoney,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].onemoney,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].onemoney,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].onemoney,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].onemoney,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].onemoney,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].onemoney,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].onemoney,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].onemoney,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].onemoney,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].onemoney,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].onemoney,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].onemoney,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].onemoney,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].onemoney,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].onemoney,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].onemoney,
          canshuxulie: 'onemoney',
          //6
        },
        {
          coding: '折扣率',
          biaozhun: '-',
          shuoming: '-',
          hejiL: allrate.zhekoulv || '',
          hejiE: allrate.zhekoulv || '',
          xinghao1: this.alllastlist[0].zhekoulv || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].zhekoulv,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].zhekoulv,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].zhekoulv,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].zhekoulv,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].zhekoulv,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].zhekoulv,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].zhekoulv,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].zhekoulv,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].zhekoulv,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].zhekoulv,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].zhekoulv,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].zhekoulv,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].zhekoulv,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].zhekoulv,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].zhekoulv,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].zhekoulv,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].zhekoulv,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].zhekoulv,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].zhekoulv,
          canshuxulie: 'zhekoulv',
          //7
        },
        {
          coding: '销量',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.productNum || '',
          xinghao1: this.alllastlist[0].productNum || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].productNum,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].productNum,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].productNum,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].productNum,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].productNum,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].productNum,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].productNum,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].productNum,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].productNum,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].productNum,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].productNum,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].productNum,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].productNum,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].productNum,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].productNum,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].productNum,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].productNum,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].productNum,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].productNum,
          canshuxulie: 'productNum',
          //8
        },
        {
          coding: '申请单价(含税)',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.shenqingdanjia || '',
          canshu: 'shenqingdanjia',
          xinghao1: this.alllastlist[0].shenqingdanjia || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].shenqingdanjia,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].shenqingdanjia,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].shenqingdanjia,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].shenqingdanjia,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].shenqingdanjia,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].shenqingdanjia,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].shenqingdanjia,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].shenqingdanjia,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].shenqingdanjia,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].shenqingdanjia,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].shenqingdanjia,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].shenqingdanjia,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].shenqingdanjia,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].shenqingdanjia,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].shenqingdanjia,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].shenqingdanjia,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].shenqingdanjia,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].shenqingdanjia,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].shenqingdanjia,
          marcode1: this.alllastlist[0].marcode || '',
          marcode2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
          marcode3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
          marcode4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
          marcode5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
          marcode6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
          marcode7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
          marcode8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
          marcode9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
          marcode10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
          marcode11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
          marcode12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
          marcode13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
          marcode14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
          marcode15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
          marcode16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].marcode,
          marcode17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].marcode,
          marcode18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].marcode,
          marcode19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].marcode,
          marcode20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].marcode,
          canshuxulie: 'shenqingdanjia',
          //9
        },
        {
          coding: '订单金额',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.dingdanjine || '',
          xinghao1: this.alllastlist[0].dingdanjine || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].dingdanjine,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].dingdanjine,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].dingdanjine,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].dingdanjine,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].dingdanjine,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].dingdanjine,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].dingdanjine,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].dingdanjine,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].dingdanjine,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].dingdanjine,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].dingdanjine,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].dingdanjine,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].dingdanjine,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].dingdanjine,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].dingdanjine,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].dingdanjine,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].dingdanjine,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].dingdanjine,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].dingdanjine,
          canshuxulie: 'dingdanjine',
          //10
        },
        {
          coding: '不含税订单收入',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.buhanshuishouru || '',
          xinghao1: this.alllastlist[0].buhanshuishouru || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].buhanshuishouru,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].buhanshuishouru,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].buhanshuishouru,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].buhanshuishouru,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].buhanshuishouru,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].buhanshuishouru,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].buhanshuishouru,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].buhanshuishouru,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].buhanshuishouru,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].buhanshuishouru,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].buhanshuishouru,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].buhanshuishouru,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].buhanshuishouru,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].buhanshuishouru,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].buhanshuishouru,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].buhanshuishouru,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].buhanshuishouru,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].buhanshuishouru,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].buhanshuishouru,
          canshuxulie: 'buhanshuishouru',
          //11
        },
        {
          coding: '盈亏平衡含税价',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.yingkuipingheng || '',
          xinghao1: this.alllastlist[0].yingkuipingheng || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].yingkuipingheng,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].yingkuipingheng,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].yingkuipingheng,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].yingkuipingheng,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].yingkuipingheng,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].yingkuipingheng,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].yingkuipingheng,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].yingkuipingheng,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].yingkuipingheng,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].yingkuipingheng,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].yingkuipingheng,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].yingkuipingheng,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].yingkuipingheng,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].yingkuipingheng,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].yingkuipingheng,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].yingkuipingheng,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].yingkuipingheng,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].yingkuipingheng,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].yingkuipingheng,
          canshuxulie: 'yingkuipingheng',
          //12
        },
        {
          message: '盈利情况',
          coding: '材料毛利',
          shuoming: '-',
          biaozhun: '-',
          hejiL:
            allrate.yinglicailiaomaoli == null ||
              allrate.yinglicailiaomaoli == '' ||
              allrate.yinglicailiaomaoli == 0 ||
              allrate.yinglicailiaomaoli == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.yinglicailiaomaoli))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.yinglicailiaomaoli || '',
          xinghao1: this.alllastlist[0].yinglicailiaomaoli || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].yinglicailiaomaoli,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].yinglicailiaomaoli,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].yinglicailiaomaoli,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].yinglicailiaomaoli,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].yinglicailiaomaoli,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].yinglicailiaomaoli,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].yinglicailiaomaoli,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].yinglicailiaomaoli,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].yinglicailiaomaoli,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].yinglicailiaomaoli,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].yinglicailiaomaoli,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].yinglicailiaomaoli,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].yinglicailiaomaoli,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].yinglicailiaomaoli,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].yinglicailiaomaoli,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].yinglicailiaomaoli,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].yinglicailiaomaoli,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].yinglicailiaomaoli,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].yinglicailiaomaoli,
          canshuxulie: 'yinglicailiaomaoli',
          //13
        },
        {
          coding: '经营贡献',
          biaozhun: '-',
          shuoming: '-',
          hejiL:
            allrate.jingyinggongxian == null ||
              allrate.jingyinggongxian == '' ||
              allrate.jingyinggongxian == 0 ||
              allrate.jingyinggongxian == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.jingyinggongxian))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.jingyinggongxian || '',
          xinghao1: this.alllastlist[0].jingyinggongxian || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].jingyinggongxian,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].jingyinggongxian,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].jingyinggongxian,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].jingyinggongxian,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].jingyinggongxian,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].jingyinggongxian,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].jingyinggongxian,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].jingyinggongxian,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].jingyinggongxian,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].jingyinggongxian,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].jingyinggongxian,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].jingyinggongxian,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].jingyinggongxian,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].jingyinggongxian,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].jingyinggongxian,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].jingyinggongxian,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].jingyinggongxian,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].jingyinggongxian,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].jingyinggongxian,
          canshuxulie: 'jingyinggongxian',
          //14
        },

        {
          coding: '利润',
          biaozhun: '-',
          shuoming: '-',
          hejiL:
            allrate.yinglilirun == null ||
              allrate.yinglilirun == '' ||
              allrate.yinglilirun == 0 ||
              allrate.yinglilirun == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.yinglilirun))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.yinglilirun || '',
          xinghao1: this.alllastlist[0].yinglilirun || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].yinglilirun,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].yinglilirun,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].yinglilirun,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].yinglilirun,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].yinglilirun,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].yinglilirun,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].yinglilirun,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].yinglilirun,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].yinglilirun,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].yinglilirun,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].yinglilirun,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].yinglilirun,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].yinglilirun,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].yinglilirun,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].yinglilirun,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].yinglilirun,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].yinglilirun,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].yinglilirun,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].yinglilirun,
          canshuxulie: 'yinglilirun',
          //15
        },
        {
          message: '毛利',
          coding: '单台成本',
          shuoming: '测算当月BOM成本',
          biaozhun: '-',
          hejiL: '-',
          hejiE: allrate.dantaichengben || '',
          xinghao1: this.alllastlist[0].dantaichengben || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].dantaichengben,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].dantaichengben,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].dantaichengben,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].dantaichengben,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].dantaichengben,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].dantaichengben,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].dantaichengben,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].dantaichengben,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].dantaichengben,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].dantaichengben,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].dantaichengben,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].dantaichengben,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].dantaichengben,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].dantaichengben,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].dantaichengben,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].dantaichengben,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].dantaichengben,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].dantaichengben,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].dantaichengben,
          canshuxulie: 'dantaichengben',
          //16
        },
        {
          coding: '成本合计',
          biaozhun: '-',
          shuoming: '-',
          hejiL:
            allrate.maolichengbenheji == null ||
              allrate.maolichengbenheji == '' ||
              allrate.maolichengbenheji == 0 ||
              allrate.maolichengbenheji == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.maolichengbenheji))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.maolichengbenheji || '',
          xinghao1: this.alllastlist[0].maolichengbenheji || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].maolichengbenheji,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].maolichengbenheji,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].maolichengbenheji,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].maolichengbenheji,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].maolichengbenheji,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].maolichengbenheji,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].maolichengbenheji,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].maolichengbenheji,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].maolichengbenheji,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].maolichengbenheji,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].maolichengbenheji,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].maolichengbenheji,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].maolichengbenheji,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].maolichengbenheji,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].maolichengbenheji,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].maolichengbenheji,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].maolichengbenheji,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].maolichengbenheji,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].maolichengbenheji,
          canshuxulie: 'maolichengbenheji',
          //17
        },
        {
          coding: '毛利',
          biaozhun: '-',
          shuoming: '-',
          hejiL:
            allrate.maolimaoli == null ||
              allrate.maolimaoli == '' ||
              allrate.maolimaoli == 0 ||
              allrate.maolimaoli == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.maolimaoli))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.maolimaoli || '',
          xinghao1: this.alllastlist[0].maolimaoli || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].maolimaoli,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].maolimaoli,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].maolimaoli,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].maolimaoli,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].maolimaoli,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].maolimaoli,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].maolimaoli,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].maolimaoli,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].maolimaoli,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].maolimaoli,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].maolimaoli,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].maolimaoli,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].maolimaoli,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].maolimaoli,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].maolimaoli,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].maolimaoli,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].maolimaoli,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].maolimaoli,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].maolimaoli,
          canshuxulie: 'maolimaoli',
          //18
        },
        {
          coding: '材料毛利率',
          biaozhun: '-',
          hejiL: '-',
          shuoming: '-',
          hejiE: allrate.maolimaolilv || '',
          xinghao1: this.alllastlist[0].maolimaolilv || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].maolimaolilv,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].maolimaolilv,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].maolimaolilv,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].maolimaolilv,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].maolimaolilv,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].maolimaolilv,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].maolimaolilv,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].maolimaolilv,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].maolimaolilv,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].maolimaolilv,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].maolimaolilv,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].maolimaolilv,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].maolimaolilv,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].maolimaolilv,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].maolimaolilv,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].maolimaolilv,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].maolimaolilv,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].maolimaolilv,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].maolimaolilv,
          canshuxulie: 'maolimaolilv',
          //19
        },
        {
          message: '直接费用',
          coding: '制造费用',
          shuoming: '材料的制造费用率',
          biaozhun: '-',
          hejiL:
            allrate.zhizaofeiyong == null ||
              allrate.zhizaofeiyong == '' ||
              allrate.zhizaofeiyong == 0 ||
              allrate.zhizaofeiyong == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.zhizaofeiyong))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.zhizaofeiyong || '',
          xinghao1: this.alllastlist[0].zhizaofeiyong || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].zhizaofeiyong,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].zhizaofeiyong,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].zhizaofeiyong,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].zhizaofeiyong,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].zhizaofeiyong,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].zhizaofeiyong,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].zhizaofeiyong,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].zhizaofeiyong,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].zhizaofeiyong,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].zhizaofeiyong,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].zhizaofeiyong,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].zhizaofeiyong,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].zhizaofeiyong,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].zhizaofeiyong,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].zhizaofeiyong,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].zhizaofeiyong,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].zhizaofeiyong,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].zhizaofeiyong,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].zhizaofeiyong,
          canshuxulie: 'zhizaofeiyong',
          //20
        },
        {
          message: '直接费用',
          coding: '附加成本',
          shuoming: '赠送耗材、周转机等成本',
          biaozhun: '-',
          hejiL:
            allrate.fujiachengben == null ||
              allrate.fujiachengben == '' ||
              allrate.fujiachengben == 0 ||
              allrate.fujiachengben == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.fujiachengben))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.fujiachengben || '',
          canshu: 'fujiachengben',
          xinghao1: this.alllastlist[0].fujiachengben || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].fujiachengben,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].fujiachengben,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].fujiachengben,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].fujiachengben,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].fujiachengben,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].fujiachengben,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].fujiachengben,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].fujiachengben,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].fujiachengben,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].fujiachengben,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].fujiachengben,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].fujiachengben,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].fujiachengben,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].fujiachengben,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].fujiachengben,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].fujiachengben,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].fujiachengben,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].fujiachengben,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].fujiachengben,
          marcode1: this.alllastlist[0].marcode || '',
          marcode2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
          marcode3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
          marcode4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
          marcode5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
          marcode6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
          marcode7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
          marcode8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
          marcode9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
          marcode10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
          marcode11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
          marcode12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
          marcode13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
          marcode14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
          marcode15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
          marcode16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].marcode,
          marcode17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].marcode,
          marcode18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].marcode,
          marcode19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].marcode,
          marcode20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].marcode,
          canshuxulie: 'fujiachengben',
          //21
        },
        {
          coding: '物流费用',
          shuoming: '单位体积',
          biaozhun: '-',
          hejiL: '-',
          hejiE: allrate.wuliufeiyongdanweitiji || '',
          xinghao1: this.alllastlist[0].wuliufeiyongdanweitiji || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].wuliufeiyongdanweitiji,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].wuliufeiyongdanweitiji,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].wuliufeiyongdanweitiji,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].wuliufeiyongdanweitiji,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].wuliufeiyongdanweitiji,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].wuliufeiyongdanweitiji,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].wuliufeiyongdanweitiji,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].wuliufeiyongdanweitiji,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].wuliufeiyongdanweitiji,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].wuliufeiyongdanweitiji,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].wuliufeiyongdanweitiji,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].wuliufeiyongdanweitiji,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].wuliufeiyongdanweitiji,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].wuliufeiyongdanweitiji,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].wuliufeiyongdanweitiji,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].wuliufeiyongdanweitiji,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].wuliufeiyongdanweitiji,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].wuliufeiyongdanweitiji,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].wuliufeiyongdanweitiji,
          canshuxulie: 'wuliufeiyongdanweitiji',
          //22
        },
        {
          coding: '-',
          shuoming: '运费',
          biaozhun: '-',
          hejiL:
            allrate.wuliufeiyongyunfei == null ||
              allrate.wuliufeiyongyunfei == '' ||
              allrate.wuliufeiyongyunfei == 0 ||
              allrate.wuliufeiyongyunfei == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.wuliufeiyongyunfei))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.wuliufeiyongyunfei || '',
          xinghao1: this.alllastlist[0].wuliufeiyongyunfei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].wuliufeiyongyunfei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].wuliufeiyongyunfei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].wuliufeiyongyunfei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].wuliufeiyongyunfei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].wuliufeiyongyunfei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].wuliufeiyongyunfei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].wuliufeiyongyunfei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].wuliufeiyongyunfei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].wuliufeiyongyunfei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].wuliufeiyongyunfei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].wuliufeiyongyunfei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].wuliufeiyongyunfei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].wuliufeiyongyunfei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].wuliufeiyongyunfei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].wuliufeiyongyunfei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].wuliufeiyongyunfei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].wuliufeiyongyunfei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].wuliufeiyongyunfei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].wuliufeiyongyunfei,
          canshuxulie: 'wuliufeiyongyunfei',
          //23
        },
        {
          coding: '安装费用',
          shuoming: '单台安装费',
          biaozhun: '-',
          hejiL: '-',
          hejiE: allrate.dantaianzhuangfei || '',
          xinghao1: this.alllastlist[0].dantaianzhuangfei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].dantaianzhuangfei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].dantaianzhuangfei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].dantaianzhuangfei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].dantaianzhuangfei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].dantaianzhuangfei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].dantaianzhuangfei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].dantaianzhuangfei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].dantaianzhuangfei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].dantaianzhuangfei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].dantaianzhuangfei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].dantaianzhuangfei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].dantaianzhuangfei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].dantaianzhuangfei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].dantaianzhuangfei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].dantaianzhuangfei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].dantaianzhuangfei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].dantaianzhuangfei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].dantaianzhuangfei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].dantaianzhuangfei,
          canshuxulie: 'dantaianzhuangfei',
          //24
        },
        {
          coding: '-',
          shuoming: '安装费',
          biaozhun: '-',
          hejiL:
            allrate.anzhuangfeianzhuangfei == null ||
              allrate.anzhuangfeianzhuangfei == '' ||
              allrate.anzhuangfeianzhuangfei == 0 ||
              allrate.anzhuangfeianzhuangfei == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.anzhuangfeianzhuangfei))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.anzhuangfeianzhuangfei || '',
          xinghao1: this.alllastlist[0].anzhuangfeianzhuangfei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].anzhuangfeianzhuangfei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].anzhuangfeianzhuangfei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].anzhuangfeianzhuangfei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].anzhuangfeianzhuangfei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].anzhuangfeianzhuangfei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].anzhuangfeianzhuangfei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].anzhuangfeianzhuangfei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].anzhuangfeianzhuangfei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].anzhuangfeianzhuangfei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].anzhuangfeianzhuangfei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].anzhuangfeianzhuangfei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].anzhuangfeianzhuangfei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].anzhuangfeianzhuangfei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].anzhuangfeianzhuangfei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].anzhuangfeianzhuangfei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].anzhuangfeianzhuangfei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].anzhuangfeianzhuangfei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].anzhuangfeianzhuangfei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].anzhuangfeianzhuangfei,
          canshuxulie: 'anzhuangfeianzhuangfei',
          //25
        },
        {
          coding: '维修费',
          shuoming: '18年到产品实际费用',
          biaozhun: '-',
          hejiL:
            allrate.zhijiefeiyongweixiufei == null ||
              allrate.zhijiefeiyongweixiufei == '' ||
              allrate.zhijiefeiyongweixiufei == 0 ||
              allrate.zhijiefeiyongweixiufei == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.zhijiefeiyongweixiufei))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.zhijiefeiyongweixiufei || '',
          xinghao1: this.alllastlist[0].zhijiefeiyongweixiufei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].zhijiefeiyongweixiufei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].zhijiefeiyongweixiufei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].zhijiefeiyongweixiufei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].zhijiefeiyongweixiufei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].zhijiefeiyongweixiufei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].zhijiefeiyongweixiufei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].zhijiefeiyongweixiufei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].zhijiefeiyongweixiufei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].zhijiefeiyongweixiufei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].zhijiefeiyongweixiufei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].zhijiefeiyongweixiufei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].zhijiefeiyongweixiufei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].zhijiefeiyongweixiufei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].zhijiefeiyongweixiufei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].zhijiefeiyongweixiufei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].zhijiefeiyongweixiufei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].zhijiefeiyongweixiufei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].zhijiefeiyongweixiufei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].zhijiefeiyongweixiufei,
          canshuxulie: 'zhijiefeiyongweixiufei',
          //26
        },
        {
          coding: '备件费',
          shuoming: '18年到产品实际费用',
          biaozhun: '-',
          hejiL:
            allrate.zhijiefeiyongbeijianfei == null ||
              allrate.zhijiefeiyongbeijianfei == '' ||
              allrate.zhijiefeiyongbeijianfei == 0 ||
              allrate.zhijiefeiyongbeijianfei == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.zhijiefeiyongbeijianfei))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.zhijiefeiyongbeijianfei || '',
          xinghao1: this.alllastlist[0].zhijiefeiyongbeijianfei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].zhijiefeiyongbeijianfei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].zhijiefeiyongbeijianfei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].zhijiefeiyongbeijianfei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].zhijiefeiyongbeijianfei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].zhijiefeiyongbeijianfei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].zhijiefeiyongbeijianfei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].zhijiefeiyongbeijianfei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].zhijiefeiyongbeijianfei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].zhijiefeiyongbeijianfei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].zhijiefeiyongbeijianfei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].zhijiefeiyongbeijianfei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].zhijiefeiyongbeijianfei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].zhijiefeiyongbeijianfei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].zhijiefeiyongbeijianfei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].zhijiefeiyongbeijianfei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].zhijiefeiyongbeijianfei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].zhijiefeiyongbeijianfei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].zhijiefeiyongbeijianfei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].zhijiefeiyongbeijianfei,
          canshuxulie: 'zhijiefeiyongbeijianfei',
          //27
        },
        {
          coding: '退换机',
          shuoming: '18年到产品实际费用',
          biaozhun: '-',
          hejiL:
            allrate.zhijiefeiyongtuihuanjifei == null ||
              allrate.zhijiefeiyongtuihuanjifei == '' ||
              allrate.zhijiefeiyongtuihuanjifei == 0 ||
              allrate.zhijiefeiyongtuihuanjifei == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.zhijiefeiyongtuihuanjifei))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.zhijiefeiyongtuihuanjifei || '',
          xinghao1: this.alllastlist[0].zhijiefeiyongtuihuanjifei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].zhijiefeiyongtuihuanjifei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].zhijiefeiyongtuihuanjifei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].zhijiefeiyongtuihuanjifei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].zhijiefeiyongtuihuanjifei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].zhijiefeiyongtuihuanjifei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].zhijiefeiyongtuihuanjifei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].zhijiefeiyongtuihuanjifei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].zhijiefeiyongtuihuanjifei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].zhijiefeiyongtuihuanjifei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].zhijiefeiyongtuihuanjifei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].zhijiefeiyongtuihuanjifei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].zhijiefeiyongtuihuanjifei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].zhijiefeiyongtuihuanjifei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].zhijiefeiyongtuihuanjifei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].zhijiefeiyongtuihuanjifei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].zhijiefeiyongtuihuanjifei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].zhijiefeiyongtuihuanjifei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].zhijiefeiyongtuihuanjifei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].zhijiefeiyongtuihuanjifei,
          canshuxulie: 'zhijiefeiyongtuihuanjifei',
          //28
        },
        {
          coding: '资金成本',
          shuoming: '资金成本损失',
          biaozhun: '-',
          hejiL:
            allrate.zijinchengben == null ||
              allrate.zijinchengben == '' ||
              allrate.zijinchengben == 0 ||
              allrate.zijinchengben == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.zijinchengben))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.zijinchengben || '',
          xinghao1: this.alllastlist[0].zijinchengben || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].zijinchengben,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].zijinchengben,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].zijinchengben,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].zijinchengben,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].zijinchengben,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].zijinchengben,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].zijinchengben,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].zijinchengben,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].zijinchengben,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].zijinchengben,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].zijinchengben,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].zijinchengben,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].zijinchengben,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].zijinchengben,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].zijinchengben,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].zijinchengben,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].zijinchengben,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].zijinchengben,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].zijinchengben,
          canshuxulie: 'zijinchengben',
          //29
        },
        {
          message: '直接费用',
          coding: '中标服务费',
          shuoming: '-',
          biaozhun: '-',
          hejiL:
            allrate.zhongbiaofuwufei == null ||
              allrate.zhongbiaofuwufei == '' ||
              allrate.zhongbiaofuwufei == 0 ||
              allrate.zhongbiaofuwufei == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.zhongbiaofuwufei))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.zhongbiaofuwufei || '',
          canshu: 'zhongbiaofuwufei',
          xinghao1: this.alllastlist[0].zhongbiaofuwufei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].zhongbiaofuwufei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].zhongbiaofuwufei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].zhongbiaofuwufei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].zhongbiaofuwufei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].zhongbiaofuwufei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].zhongbiaofuwufei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].zhongbiaofuwufei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].zhongbiaofuwufei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].zhongbiaofuwufei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].zhongbiaofuwufei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].zhongbiaofuwufei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].zhongbiaofuwufei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].zhongbiaofuwufei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].zhongbiaofuwufei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].zhongbiaofuwufei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].zhongbiaofuwufei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].zhongbiaofuwufei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].zhongbiaofuwufei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].zhongbiaofuwufei,
          marcode1: this.alllastlist[0].marcode || '',
          marcode2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
          marcode3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
          marcode4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
          marcode5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
          marcode6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
          marcode7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
          marcode8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
          marcode9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
          marcode10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
          marcode11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
          marcode12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
          marcode13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
          marcode14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
          marcode15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
          marcode16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].marcode,
          marcode17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].marcode,
          marcode18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].marcode,
          marcode19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].marcode,
          marcode20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].marcode,
          canshuxulie: 'zhongbiaofuwufei',
          //30
        },
        {
          coding: '税费',
          shuoming: '维修基金',
          biaozhun: '-',
          hejiL:
            allrate.weixiujijin == null ||
              allrate.weixiujijin == '' ||
              allrate.weixiujijin == 0 ||
              allrate.weixiujijin == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.weixiujijin))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.weixiujijin || '',

          xinghao1: this.alllastlist[0].weixiujijin || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].weixiujijin,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].weixiujijin,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].weixiujijin,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].weixiujijin,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].weixiujijin,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].weixiujijin,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].weixiujijin,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].weixiujijin,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].weixiujijin,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].weixiujijin,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].weixiujijin,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].weixiujijin,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].weixiujijin,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].weixiujijin,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].weixiujijin,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].weixiujijin,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].weixiujijin,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].weixiujijin,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].weixiujijin,
          canshuxulie: 'weixiujijin',
          //31
        },
        {
          coding: '-',
          shuoming: '其他税费',
          biaozhun: '-',
          hejiL:
            allrate.shuifeiqitashuifei == null ||
              allrate.shuifeiqitashuifei == '' ||
              allrate.shuifeiqitashuifei == 0 ||
              allrate.shuifeiqitashuifei == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.shuifeiqitashuifei))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.shuifeiqitashuifei || '',

          xinghao1: this.alllastlist[0].shuifeiqitashuifei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].shuifeiqitashuifei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].shuifeiqitashuifei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].shuifeiqitashuifei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].shuifeiqitashuifei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].shuifeiqitashuifei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].shuifeiqitashuifei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].shuifeiqitashuifei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].shuifeiqitashuifei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].shuifeiqitashuifei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].shuifeiqitashuifei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].shuifeiqitashuifei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].shuifeiqitashuifei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].shuifeiqitashuifei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].shuifeiqitashuifei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].shuifeiqitashuifei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].shuifeiqitashuifei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].shuifeiqitashuifei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].shuifeiqitashuifei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].shuifeiqitashuifei,
          canshuxulie: 'shuifeiqitashuifei',
          //32
        },

        {
          coding: '销售费用',
          shuoming: '销售人工',
          biaozhun: '-',
          hejiL:
            allrate.xiaoshoufeiyongrengong == null ||
              allrate.xiaoshoufeiyongrengong == '' ||
              allrate.xiaoshoufeiyongrengong == 0 ||
              allrate.xiaoshoufeiyongrengong == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.xiaoshoufeiyongrengong))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.xiaoshoufeiyongrengong || '',

          xinghao1: this.alllastlist[0].xiaoshoufeiyongrengong || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].xiaoshoufeiyongrengong,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].xiaoshoufeiyongrengong,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].xiaoshoufeiyongrengong,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].xiaoshoufeiyongrengong,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].xiaoshoufeiyongrengong,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].xiaoshoufeiyongrengong,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].xiaoshoufeiyongrengong,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].xiaoshoufeiyongrengong,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].xiaoshoufeiyongrengong,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].xiaoshoufeiyongrengong,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].xiaoshoufeiyongrengong,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].xiaoshoufeiyongrengong,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].xiaoshoufeiyongrengong,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].xiaoshoufeiyongrengong,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].xiaoshoufeiyongrengong,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].xiaoshoufeiyongrengong,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].xiaoshoufeiyongrengong,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].xiaoshoufeiyongrengong,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].xiaoshoufeiyongrengong,
          canshuxulie: 'xiaoshoufeiyongrengong',
          //33
        },
        {
          coding: '',
          shuoming: '销售组织运营',
          biaozhun: '-',
          hejiL:
            allrate.xiaoshouzuzhiyunying == null ||
              allrate.xiaoshouzuzhiyunying == '' ||
              allrate.xiaoshouzuzhiyunying == 0 ||
              allrate.xiaoshouzuzhiyunying == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.xiaoshouzuzhiyunying))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.xiaoshouzuzhiyunying || '',

          xinghao1: this.alllastlist[0].xiaoshouzuzhiyunying || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].xiaoshouzuzhiyunying,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].xiaoshouzuzhiyunying,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].xiaoshouzuzhiyunying,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].xiaoshouzuzhiyunying,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].xiaoshouzuzhiyunying,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].xiaoshouzuzhiyunying,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].xiaoshouzuzhiyunying,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].xiaoshouzuzhiyunying,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].xiaoshouzuzhiyunying,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].xiaoshouzuzhiyunying,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].xiaoshouzuzhiyunying,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].xiaoshouzuzhiyunying,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].xiaoshouzuzhiyunying,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].xiaoshouzuzhiyunying,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].xiaoshouzuzhiyunying,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].xiaoshouzuzhiyunying,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].xiaoshouzuzhiyunying,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].xiaoshouzuzhiyunying,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].xiaoshouzuzhiyunying,
          canshuxulie: 'xiaoshouzuzhiyunying',
          //34
        },
        {
          coding: '研发费用',
          shuoming: '研发人工',
          biaozhun: '-',
          hejiL:
            allrate.yanfarengong == null ||
              allrate.yanfarengong == '' ||
              allrate.yanfarengong == 0 ||
              allrate.yanfarengong == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.yanfarengong))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.yanfarengong || '',

          xinghao1: this.alllastlist[0].yanfarengong || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].yanfarengong,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].yanfarengong,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].yanfarengong,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].yanfarengong,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].yanfarengong,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].yanfarengong,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].yanfarengong,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].yanfarengong,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].yanfarengong,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].yanfarengong,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].yanfarengong,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].yanfarengong,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].yanfarengong,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].yanfarengong,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].yanfarengong,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].yanfarengong,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].yanfarengong,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].yanfarengong,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].yanfarengong,
          canshuxulie: 'yanfarengong',
          //35
        },
        {
          coding: '-',
          shuoming: '研发组织运营',
          biaozhun: '-',
          hejiL:
            allrate.yanfayunying == null ||
              allrate.yanfayunying == '' ||
              allrate.yanfayunying == 0 ||
              allrate.yanfayunying == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.yanfayunying))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.yanfayunying || '',

          xinghao1: this.alllastlist[0].yanfayunying || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].yanfayunying,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].yanfayunying,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].yanfayunying,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].yanfayunying,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].yanfayunying,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].yanfayunying,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].yanfayunying,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].yanfayunying,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].yanfayunying,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].yanfayunying,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].yanfayunying,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].yanfayunying,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].yanfayunying,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].yanfayunying,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].yanfayunying,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].yanfayunying,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].yanfayunying,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].yanfayunying,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].yanfayunying,
          canshuxulie: 'yanfayunying',
          //36
        },
        {
          coding: '直接费用小计',
          shuoming: '-',
          biaozhun: '-',
          hejiL:
            allrate.zhijiefeiyongxiaoji == null ||
              allrate.zhijiefeiyongxiaoji == '' ||
              allrate.zhijiefeiyongxiaoji == 0 ||
              allrate.zhijiefeiyongxiaoji == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.zhijiefeiyongxiaoji))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.zhijiefeiyongxiaoji || '',
          xinghao1: this.alllastlist[0].zhijiefeiyongxiaoji || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].zhijiefeiyongxiaoji,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].zhijiefeiyongxiaoji,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].zhijiefeiyongxiaoji,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].zhijiefeiyongxiaoji,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].zhijiefeiyongxiaoji,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].zhijiefeiyongxiaoji,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].zhijiefeiyongxiaoji,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].zhijiefeiyongxiaoji,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].zhijiefeiyongxiaoji,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].zhijiefeiyongxiaoji,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].zhijiefeiyongxiaoji,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].zhijiefeiyongxiaoji,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].zhijiefeiyongxiaoji,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].zhijiefeiyongxiaoji,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].zhijiefeiyongxiaoji,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].zhijiefeiyongxiaoji,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].zhijiefeiyongxiaoji,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].zhijiefeiyongxiaoji,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].zhijiefeiyongxiaoji,
          canshuxulie: 'zhijiefeiyongxiaoji',
          //37
        },
        {
          message: '经营贡献',
          coding: '经营贡献',
          shuoming: '-',
          biaozhun: '-',
          hejiL:
            allrate.jingyinggongxiansan == null ||
              allrate.jingyinggongxiansan == '' ||
              allrate.jingyinggongxiansan == 0 ||
              allrate.jingyinggongxiansan == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.jingyinggongxiansan))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.jingyinggongxiansan || '',
          xinghao1: this.alllastlist[0].jingyinggongxiansan || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].jingyinggongxiansan,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].jingyinggongxiansan,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].jingyinggongxiansan,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].jingyinggongxiansan,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].jingyinggongxiansan,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].jingyinggongxiansan,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].jingyinggongxiansan,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].jingyinggongxiansan,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].jingyinggongxiansan,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].jingyinggongxiansan,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].jingyinggongxiansan,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].jingyinggongxiansan,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].jingyinggongxiansan,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].jingyinggongxiansan,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].jingyinggongxiansan,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].jingyinggongxiansan,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].jingyinggongxiansan,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].jingyinggongxiansan,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].jingyinggongxiansan,
          canshuxulie: 'jingyinggongxiansan',
          //38
        },
        {
          coding: '经营贡献率',
          shuoming: '-',
          biaozhun: '-',
          hejiL: '-',
          hejiE: allrate.jingyinggongxianlv || '',
          xinghao1: this.alllastlist[0].jingyinggongxianlv || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].jingyinggongxianlv,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].jingyinggongxianlv,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].jingyinggongxianlv,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].jingyinggongxianlv,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].jingyinggongxianlv,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].jingyinggongxianlv,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].jingyinggongxianlv,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].jingyinggongxianlv,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].jingyinggongxianlv,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].jingyinggongxianlv,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].jingyinggongxianlv,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].jingyinggongxianlv,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].jingyinggongxianlv,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].jingyinggongxianlv,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].jingyinggongxianlv,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].jingyinggongxianlv,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].jingyinggongxianlv,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].jingyinggongxianlv,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].jingyinggongxianlv,
          canshuxulie: 'jingyinggongxianlv',
          //39
        },
        {
          message: '平台费用',
          coding: '销售费用',
          shuoming: '-',
          biaozhun: '-',
          hejiL:
            allrate.pingtaixiaoshoufeiyong == null ||
              allrate.pingtaixiaoshoufeiyong == '' ||
              allrate.pingtaixiaoshoufeiyong == 0 ||
              allrate.pingtaixiaoshoufeiyong == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.pingtaixiaoshoufeiyong))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.pingtaixiaoshoufeiyong || '',
          xinghao1: this.alllastlist[0].pingtaixiaoshoufeiyong || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].pingtaixiaoshoufeiyong,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].pingtaixiaoshoufeiyong,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].pingtaixiaoshoufeiyong,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].pingtaixiaoshoufeiyong,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].pingtaixiaoshoufeiyong,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].pingtaixiaoshoufeiyong,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].pingtaixiaoshoufeiyong,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].pingtaixiaoshoufeiyong,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].pingtaixiaoshoufeiyong,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].pingtaixiaoshoufeiyong,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].pingtaixiaoshoufeiyong,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].pingtaixiaoshoufeiyong,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].pingtaixiaoshoufeiyong,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].pingtaixiaoshoufeiyong,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].pingtaixiaoshoufeiyong,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].pingtaixiaoshoufeiyong,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].pingtaixiaoshoufeiyong,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].pingtaixiaoshoufeiyong,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].pingtaixiaoshoufeiyong,
          canshuxulie: 'pingtaixiaoshoufeiyong',
          //40
        },
        {
          coding: '管理费用',
          shuoming: '-',
          biaozhun: '-',
          hejiL:
            allrate.pingtaiguanlifeiyong == null ||
              allrate.pingtaiguanlifeiyong == '' ||
              allrate.pingtaiguanlifeiyong == 0 ||
              allrate.pingtaiguanlifeiyong == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.pingtaiguanlifeiyong))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.pingtaiguanlifeiyong || '',
          xinghao1: this.alllastlist[0].pingtaiguanlifeiyong || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].pingtaiguanlifeiyong,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].pingtaiguanlifeiyong,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].pingtaiguanlifeiyong,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].pingtaiguanlifeiyong,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].pingtaiguanlifeiyong,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].pingtaiguanlifeiyong,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].pingtaiguanlifeiyong,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].pingtaiguanlifeiyong,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].pingtaiguanlifeiyong,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].pingtaiguanlifeiyong,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].pingtaiguanlifeiyong,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].pingtaiguanlifeiyong,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].pingtaiguanlifeiyong,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].pingtaiguanlifeiyong,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].pingtaiguanlifeiyong,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].pingtaiguanlifeiyong,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].pingtaiguanlifeiyong,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].pingtaiguanlifeiyong,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].pingtaiguanlifeiyong,
          canshuxulie: 'pingtaiguanlifeiyong',
          //41
        },
        {
          coding: '研发费用',
          shuoming: '-',
          biaozhun: '-',
          hejiL:
            allrate.pingtaiyanfafeiyong == null ||
              allrate.pingtaiyanfafeiyong == '' ||
              allrate.pingtaiyanfafeiyong == 0 ||
              allrate.pingtaiyanfafeiyong == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.pingtaiyanfafeiyong))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.pingtaiyanfafeiyong || '',
          xinghao1: this.alllastlist[0].pingtaiyanfafeiyong || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].pingtaiyanfafeiyong,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].pingtaiyanfafeiyong,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].pingtaiyanfafeiyong,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].pingtaiyanfafeiyong,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].pingtaiyanfafeiyong,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].pingtaiyanfafeiyong,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].pingtaiyanfafeiyong,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].pingtaiyanfafeiyong,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].pingtaiyanfafeiyong,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].pingtaiyanfafeiyong,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].pingtaiyanfafeiyong,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].pingtaiyanfafeiyong,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].pingtaiyanfafeiyong,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].pingtaiyanfafeiyong,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].pingtaiyanfafeiyong,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].pingtaiyanfafeiyong,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].pingtaiyanfafeiyong,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].pingtaiyanfafeiyong,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].pingtaiyanfafeiyong,
          canshuxulie: 'pingtaiyanfafeiyong',
          //42
        },
        {
          coding: '平台费用小计',
          shuoming: '-',
          biaozhun: '-',
          hejiL:
            allrate.pingtaifeiyongxiaoji == null ||
              allrate.pingtaifeiyongxiaoji == '' ||
              allrate.pingtaifeiyongxiaoji == 0 ||
              allrate.pingtaifeiyongxiaoji == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.pingtaifeiyongxiaoji))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.pingtaifeiyongxiaoji || '',
          xinghao1: this.alllastlist[0].pingtaifeiyongxiaoji || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].pingtaifeiyongxiaoji,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].pingtaifeiyongxiaoji,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].pingtaifeiyongxiaoji,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].pingtaifeiyongxiaoji,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].pingtaifeiyongxiaoji,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].pingtaifeiyongxiaoji,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].pingtaifeiyongxiaoji,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].pingtaifeiyongxiaoji,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].pingtaifeiyongxiaoji,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].pingtaifeiyongxiaoji,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].pingtaifeiyongxiaoji,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].pingtaifeiyongxiaoji,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].pingtaifeiyongxiaoji,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].pingtaifeiyongxiaoji,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].pingtaifeiyongxiaoji,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].pingtaifeiyongxiaoji,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].pingtaifeiyongxiaoji,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].pingtaifeiyongxiaoji,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].pingtaifeiyongxiaoji,
          canshuxulie: 'pingtaifeiyongxiaoji',
          //43
        },
        {
          message: '利润',
          coding: '利润',
          shuoming: '-',
          biaozhun: '-',
          hejiL:
            allrate.lirunsan == null ||
              allrate.lirunsan == '' ||
              allrate.lirunsan == 0 ||
              allrate.lirunsan == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.lirunsan))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.lirunsan || '',
          xinghao1: this.alllastlist[0].lirunsan || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].lirunsan,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].lirunsan,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].lirunsan,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].lirunsan,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].lirunsan,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].lirunsan,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].lirunsan,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].lirunsan,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].lirunsan,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].lirunsan,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].lirunsan,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].lirunsan,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].lirunsan,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].lirunsan,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].lirunsan,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].lirunsan,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].lirunsan,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].lirunsan,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].lirunsan,
          canshuxulie: 'lirunsan',
          //44
        },
        {
          coding: '利润率',
          shuoming: '-',
          biaozhun: '-',
          hejiL: '-',
          hejiE: allrate.lirunlirunlv || '',
          xinghao1: this.alllastlist[0].lirunlirunlv || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].lirunlirunlv,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].lirunlirunlv,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].lirunlirunlv,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].lirunlirunlv,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].lirunlirunlv,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].lirunlirunlv,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].lirunlirunlv,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].lirunlirunlv,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].lirunlirunlv,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].lirunlirunlv,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].lirunlirunlv,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].lirunlirunlv,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].lirunlirunlv,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].lirunlirunlv,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].lirunlirunlv,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].lirunlirunlv,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].lirunlirunlv,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].lirunlirunlv,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].lirunlirunlv,
          canshuxulie: 'lirunlirunlv',
          //45
        },
      ]
      // 人工
      let rengongchengbenAll = _.reduce(_.map(this.alllastlist, "rengongchengben"), function (sum, v) {
        return new big(sum).plus(v).toString();
      }, 0)
      //组织
      let zuzhiyunyingfeiAll = _.reduce(_.map(this.alllastlist, "zuzhiyunyingfei"), function (sum, v) {
        return new big(sum).plus(v).toString();
      }, 0)
      //营销
      let yingxiaofeiAll = _.reduce(_.map(this.alllastlist, "yingxiaofei"), function (sum, v) {
        return new big(sum).plus(v).toString();
      }, 0)
      //物流
      let wuliufeiAll = _.reduce(_.map(this.alllastlist, "wuliufei"), function (sum, v) {
        return new big(sum).plus(v).toString();
      }, 0)
      //售后
      let shouhoufeiAll = _.reduce(_.map(this.alllastlist, "shouhoufei"), function (sum, v) {
        return new big(sum).plus(v).toString();
      }, 0)
      //税费
      let shuifeiAll = _.reduce(_.map(this.alllastlist, "shuifei"), function (sum, v) {
        return new big(sum).plus(v).toString();
      }, 0)
      //资产减值损失
      let zichanjianzhisunshiAll = _.reduce(_.map(this.alllastlist, "zichanjianzhisunshi"), function (sum, v) {
        return new big(sum).plus(v).toString();
      }, 0)
      // 区域费用相加
      let numAll = Number(rengongchengbenAll || 0) + Number(zuzhiyunyingfeiAll || 0) + Number(yingxiaofeiAll || 0) + Number(wuliufeiAll || 0) + Number(shouhoufeiAll || 0) + Number(shuifeiAll || 0) + Number(zichanjianzhisunshiAll || 0)
      // 计算区域经利润合计额
      let quyullirunAll = new big(allrate.maolimaoli || 0).minus(allrate.zhizaofeiyong || 0).minus(numAll).toString()
      // 计算利润率
      let quyulirunlvAll = Number(quyullirunAll) / Number(allrate.buhanshuishouru || 0)
      allrate.rengongchengbenAll = rengongchengbenAll
      allrate.zuzhiyunyingfeiAll = zuzhiyunyingfeiAll
      allrate.yingxiaofeiAll = yingxiaofeiAll
      allrate.wuliufeiAll = wuliufeiAll
      allrate.shouhoufeiAll = shouhoufeiAll
      allrate.shuifeiAll = shuifeiAll
      allrate.zichanjianzhisunshiAll = zichanjianzhisunshiAll
      allrate.quyullirunAll = quyullirunAll
      allrate.quyulirunlvAll = quyulirunlvAll


      this.alllastlist = this.alllastlist.map(item => {
        let num = Number(item.rengongchengben || 0)
          + Number(item.zuzhiyunyingfei || 0)
          + Number(item.yingxiaofei || 0)
          + Number(item.wuliufei || 0)
          + Number(item.shouhoufei || 0)
          + Number(item.shuifei || 0)
          + Number(item.zichanjianzhisunshi || 0)
        //计算区域经营利润
        let quyullirun = new big(item.maolimaoli).minus(item.zhizaofeiyong).minus(num).toString()
        //计算利润率
        let quyulirunlv = Number(quyullirun) / Number(item.buhanshuishouru || 0)
        return {
          ...item,
          quyullirun: quyullirun,
          quyulirunlv: quyulirunlv
        }
      })
      // console.log(this.alllastlist, 'lixiaotong111111111111111')
      // -----------------------分割线-区域-----------------------------------
      this.regionData = [
        {
          message: '收入',
          coding: '单台一级供价',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.onemoney || '',
          xinghao1: this.alllastlist[0].onemoney || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].onemoney,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].onemoney,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].onemoney,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].onemoney,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].onemoney,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].onemoney,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].onemoney,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].onemoney,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].onemoney,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].onemoney,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].onemoney,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].onemoney,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].onemoney,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].onemoney,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].onemoney,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].onemoney,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].onemoney,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].onemoney,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].onemoney,
          canshuxulie: 'onemoney',
          //6
        },
        {
          message: '收入',
          coding: '折扣率',
          biaozhun: '-',
          shuoming: '-',
          hejiL: allrate.zhekoulv || '',
          hejiE: allrate.zhekoulv || '',
          xinghao1: this.alllastlist[0].zhekoulv || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].zhekoulv,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].zhekoulv,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].zhekoulv,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].zhekoulv,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].zhekoulv,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].zhekoulv,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].zhekoulv,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].zhekoulv,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].zhekoulv,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].zhekoulv,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].zhekoulv,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].zhekoulv,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].zhekoulv,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].zhekoulv,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].zhekoulv,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].zhekoulv,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].zhekoulv,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].zhekoulv,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].zhekoulv,
          canshuxulie: 'zhekoulv',
          //7
        },
        {
          message: '收入',
          coding: '销量',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.productNum || '',
          xinghao1: this.alllastlist[0].productNum || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].productNum,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].productNum,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].productNum,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].productNum,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].productNum,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].productNum,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].productNum,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].productNum,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].productNum,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].productNum,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].productNum,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].productNum,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].productNum,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].productNum,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].productNum,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].productNum,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].productNum,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].productNum,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].productNum,
          canshuxulie: 'productNum',
          //8
        },
        {
          message: '收入',
          coding: '申请单价(含税)',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.shenqingdanjia || '',
          canshu: 'shenqingdanjia',
          xinghao1: this.alllastlist[0].shenqingdanjia || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].shenqingdanjia,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].shenqingdanjia,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].shenqingdanjia,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].shenqingdanjia,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].shenqingdanjia,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].shenqingdanjia,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].shenqingdanjia,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].shenqingdanjia,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].shenqingdanjia,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].shenqingdanjia,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].shenqingdanjia,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].shenqingdanjia,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].shenqingdanjia,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].shenqingdanjia,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].shenqingdanjia,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].shenqingdanjia,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].shenqingdanjia,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].shenqingdanjia,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].shenqingdanjia,
          marcode1: this.alllastlist[0].marcode || '',
          marcode2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
          marcode3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
          marcode4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
          marcode5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
          marcode6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
          marcode7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
          marcode8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
          marcode9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
          marcode10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
          marcode11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
          marcode12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
          marcode13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
          marcode14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
          marcode15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
          marcode16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].marcode,
          marcode17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].marcode,
          marcode18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].marcode,
          marcode19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].marcode,
          marcode20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].marcode,
          canshuxulie: 'shenqingdanjia',
          //9
        },
        {
          message: '收入',
          coding: '订单金额',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.dingdanjine || '',
          xinghao1: this.alllastlist[0].dingdanjine || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].dingdanjine,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].dingdanjine,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].dingdanjine,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].dingdanjine,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].dingdanjine,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].dingdanjine,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].dingdanjine,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].dingdanjine,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].dingdanjine,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].dingdanjine,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].dingdanjine,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].dingdanjine,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].dingdanjine,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].dingdanjine,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].dingdanjine,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].dingdanjine,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].dingdanjine,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].dingdanjine,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].dingdanjine,
          canshuxulie: 'dingdanjine',
          //10
        },
        {
          message: '收入',
          coding: '不含税订单收入',
          biaozhun: '-',
          shuoming: '-',
          hejiL: '-',
          hejiE: allrate.buhanshuishouru || '',
          xinghao1: this.alllastlist[0].buhanshuishouru || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].buhanshuishouru,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].buhanshuishouru,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].buhanshuishouru,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].buhanshuishouru,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].buhanshuishouru,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].buhanshuishouru,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].buhanshuishouru,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].buhanshuishouru,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].buhanshuishouru,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].buhanshuishouru,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].buhanshuishouru,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].buhanshuishouru,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].buhanshuishouru,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].buhanshuishouru,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].buhanshuishouru,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].buhanshuishouru,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].buhanshuishouru,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].buhanshuishouru,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].buhanshuishouru,
          canshuxulie: 'buhanshuishouru',
          //11
        },
        {
          message: '毛利',
          coding: '单台成本',
          shuoming: '测算当月BOM成本',
          biaozhun: '-',
          hejiL: '-',
          hejiE: allrate.dantaichengben || '',
          xinghao1: this.alllastlist[0].dantaichengben || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].dantaichengben,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].dantaichengben,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].dantaichengben,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].dantaichengben,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].dantaichengben,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].dantaichengben,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].dantaichengben,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].dantaichengben,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].dantaichengben,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].dantaichengben,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].dantaichengben,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].dantaichengben,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].dantaichengben,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].dantaichengben,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].dantaichengben,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].dantaichengben,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].dantaichengben,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].dantaichengben,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].dantaichengben,
          canshuxulie: 'dantaichengben',
          //16
        },
        {
          message: '毛利',
          coding: '成本合计',
          shuoming: '-',
          biaozhun: '-',
          hejiL:
            allrate.maolichengbenheji == null ||
              allrate.maolichengbenheji == '' ||
              allrate.maolichengbenheji == 0 ||
              allrate.maolichengbenheji == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.maolichengbenheji))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.maolichengbenheji || '',
          xinghao1: this.alllastlist[0].maolichengbenheji || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].maolichengbenheji,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].maolichengbenheji,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].maolichengbenheji,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].maolichengbenheji,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].maolichengbenheji,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].maolichengbenheji,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].maolichengbenheji,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].maolichengbenheji,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].maolichengbenheji,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].maolichengbenheji,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].maolichengbenheji,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].maolichengbenheji,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].maolichengbenheji,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].maolichengbenheji,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].maolichengbenheji,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].maolichengbenheji,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].maolichengbenheji,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].maolichengbenheji,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].maolichengbenheji,
          canshuxulie: 'maolichengbenheji',
          //17
        },
        {
          message: '毛利',
          coding: '毛利',
          biaozhun: '-',
          shuoming: '-',
          hejiL:
            allrate.maolimaoli == null ||
              allrate.maolimaoli == '' ||
              allrate.maolimaoli == 0 ||
              allrate.maolimaoli == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.maolimaoli))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.maolimaoli || '',
          xinghao1: this.alllastlist[0].maolimaoli || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].maolimaoli,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].maolimaoli,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].maolimaoli,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].maolimaoli,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].maolimaoli,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].maolimaoli,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].maolimaoli,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].maolimaoli,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].maolimaoli,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].maolimaoli,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].maolimaoli,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].maolimaoli,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].maolimaoli,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].maolimaoli,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].maolimaoli,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].maolimaoli,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].maolimaoli,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].maolimaoli,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].maolimaoli,
          canshuxulie: 'maolimaoli',
          //18
        },
        {
          message: '毛利',
          coding: '材料毛利率',
          shuoming: '-',
          biaozhun: '-',
          hejiL: '-',
          hejiE: allrate.maolimaolilv || '',
          xinghao1: this.alllastlist[0].maolimaolilv || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].maolimaolilv,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].maolimaolilv,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].maolimaolilv,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].maolimaolilv,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].maolimaolilv,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].maolimaolilv,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].maolimaolilv,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].maolimaolilv,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].maolimaolilv,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].maolimaolilv,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].maolimaolilv,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].maolimaolilv,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].maolimaolilv,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].maolimaolilv,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].maolimaolilv,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].maolimaolilv,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].maolimaolilv,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].maolimaolilv,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].maolimaolilv,
          canshuxulie: 'maolimaolilv',
          //19
        },
        {
          message: '费用',
          coding: '制造费用',
          shuoming: '到型号制造费用',
          biaozhun: '-',
          hejiL:
            allrate.zhizaofeiyong == null ||
              allrate.zhizaofeiyong == '' ||
              allrate.zhizaofeiyong == 0 ||
              allrate.zhizaofeiyong == '0' ||
              allrate.buhanshuishouru == null ||
              allrate.buhanshuishouru == '' ||
              allrate.buhanshuishouru == 0 ||
              allrate.buhanshuishouru == '0'
              ? 0
              : new big(parseFloat(allrate.zhizaofeiyong))
                .div(parseFloat(allrate.buhanshuishouru))
                .toFixed(2)
                .toString() || '',
          hejiE: allrate.zhizaofeiyong || '',
          xinghao1: this.alllastlist[0].zhizaofeiyong || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].zhizaofeiyong,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].zhizaofeiyong,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].zhizaofeiyong,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].zhizaofeiyong,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].zhizaofeiyong,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].zhizaofeiyong,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].zhizaofeiyong,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].zhizaofeiyong,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].zhizaofeiyong,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].zhizaofeiyong,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].zhizaofeiyong,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].zhizaofeiyong,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].zhizaofeiyong,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].zhizaofeiyong,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].zhizaofeiyong,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].zhizaofeiyong,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].zhizaofeiyong,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].zhizaofeiyong,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].zhizaofeiyong,
          canshuxulie: 'zhizaofeiyong',
          //20
        },
        {
          message: '费用',
          coding: '区域费用',
          shuoming: '人工成本',
          biaozhun: '-',
          hejiL: this.regionalFees ? this.regionalFees.rengongchengben : '-',
          hejiE: allrate.rengongchengbenAll || '',
          xinghao1: this.alllastlist[0].rengongchengben || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].rengongchengben,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].rengongchengben,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].rengongchengben,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].rengongchengben,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].rengongchengben,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].rengongchengben,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].rengongchengben,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].rengongchengben,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].rengongchengben,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].rengongchengben,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].rengongchengben,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].rengongchengben,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].rengongchengben,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].rengongchengben,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].rengongchengben,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].rengongchengben,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].rengongchengben,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].rengongchengben,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].rengongchengben,
          canshuxulie: 'rengongchengben'
        },
        {
          message: '费用',
          coding: '区域费用',
          shuoming: '组织运营费',
          biaozhun: '-',
          hejiL: this.regionalFees ? this.regionalFees.zuzhiyunyingfei : '-',
          hejiE: allrate.zuzhiyunyingfeiAll || '',
          xinghao1: this.alllastlist[0].zuzhiyunyingfei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].zuzhiyunyingfei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].zuzhiyunyingfei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].zuzhiyunyingfei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].zuzhiyunyingfei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].zuzhiyunyingfei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].zuzhiyunyingfei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].zuzhiyunyingfei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].zuzhiyunyingfei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].zuzhiyunyingfei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].zuzhiyunyingfei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].zuzhiyunyingfei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].zuzhiyunyingfei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].zuzhiyunyingfei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].zuzhiyunyingfei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].zuzhiyunyingfei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].zuzhiyunyingfei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].zuzhiyunyingfei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].zuzhiyunyingfei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].zuzhiyunyingfei,
          canshuxulie: 'zuzhiyunyingfei'
        },
        {
          message: '费用',
          coding: '区域费用',
          shuoming: '营销费用',
          biaozhun: '-',
          hejiL: this.regionalFees ? this.regionalFees.yingxiaofei : '-',
          hejiE: allrate.yingxiaofeiAll || '',
          xinghao1: this.alllastlist[0].yingxiaofei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].yingxiaofei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].yingxiaofei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].yingxiaofei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].yingxiaofei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].yingxiaofei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].yingxiaofei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].yingxiaofei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].yingxiaofei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].yingxiaofei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].yingxiaofei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].yingxiaofei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].yingxiaofei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].yingxiaofei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].yingxiaofei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].yingxiaofei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].yingxiaofei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].yingxiaofei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].yingxiaofei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].yingxiaofei,
          canshuxulie: 'yingxiaofei'
        },
        {
          message: '费用',
          coding: '区域费用',
          shuoming: '物流费用',
          biaozhun: '-',
          hejiL: this.regionalFees ? this.regionalFees.wuliufei : '-',
          hejiE: allrate.wuliufeiAll || '',
          xinghao1: this.alllastlist[0].wuliufei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].wuliufei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].wuliufei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].wuliufei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].wuliufei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].wuliufei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].wuliufei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].wuliufei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].wuliufei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].wuliufei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].wuliufei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].wuliufei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].wuliufei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].wuliufei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].wuliufei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].wuliufei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].wuliufei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].wuliufei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].wuliufei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].wuliufei,
          canshuxulie: 'wuliufei'
        },
        {
          message: '费用',
          coding: '区域费用',
          shuoming: '售后费用',
          biaozhun: '-',
          hejiL: this.regionalFees ? this.regionalFees.shouhoufei : '-',
          hejiE: allrate.shouhoufeiAll || '',
          xinghao1: this.alllastlist[0].shouhoufei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].shouhoufei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].shouhoufei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].shouhoufei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].shouhoufei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].shouhoufei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].shouhoufei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].shouhoufei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].shouhoufei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].shouhoufei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].shouhoufei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].shouhoufei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].shouhoufei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].shouhoufei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].shouhoufei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].shouhoufei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].shouhoufei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].shouhoufei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].shouhoufei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].shouhoufei,
          canshuxulie: 'shouhoufei'
        },
        {
          message: '费用',
          coding: '区域费用',
          shuoming: '税费',
          biaozhun: '-',
          hejiL: this.regionalFees ? this.regionalFees.shuifei : '-',
          hejiE: allrate.shuifeiAll || '',
          xinghao1: this.alllastlist[0].shuifei || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].shuifei,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].shuifei,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].shuifei,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].shuifei,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].shuifei,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].shuifei,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].shuifei,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].shuifei,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].shuifei,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].shuifei,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].shuifei,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].shuifei,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].shuifei,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].shuifei,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].shuifei,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].shuifei,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].shuifei,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].shuifei,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].shuifei,
          canshuxulie: 'shuifei'
        },
        {
          message: '费用',
          coding: '区域费用',
          shuoming: '资产减值损失',
          biaozhun: '-',
          hejiL: this.regionalFees ? this.regionalFees.zichanjianzhisunshi : '-',
          hejiE: allrate.zichanjianzhisunshiAll || '',
          xinghao1: this.alllastlist[0].zichanjianzhisunshi || '',
          xinghao2:
            this.alllastlist[1] == null
              ? ''
              : this.alllastlist[1].zichanjianzhisunshi,
          xinghao3:
            this.alllastlist[2] == null
              ? ''
              : this.alllastlist[2].zichanjianzhisunshi,
          xinghao4:
            this.alllastlist[3] == null
              ? ''
              : this.alllastlist[3].zichanjianzhisunshi,
          xinghao5:
            this.alllastlist[4] == null
              ? ''
              : this.alllastlist[4].zichanjianzhisunshi,
          xinghao6:
            this.alllastlist[5] == null
              ? ''
              : this.alllastlist[5].zichanjianzhisunshi,
          xinghao7:
            this.alllastlist[6] == null
              ? ''
              : this.alllastlist[6].zichanjianzhisunshi,
          xinghao8:
            this.alllastlist[7] == null
              ? ''
              : this.alllastlist[7].zichanjianzhisunshi,
          xinghao9:
            this.alllastlist[8] == null
              ? ''
              : this.alllastlist[8].zichanjianzhisunshi,
          xinghao10:
            this.alllastlist[9] == null
              ? ''
              : this.alllastlist[9].zichanjianzhisunshi,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].zichanjianzhisunshi,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].zichanjianzhisunshi,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].zichanjianzhisunshi,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].zichanjianzhisunshi,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].zichanjianzhisunshi,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].zichanjianzhisunshi,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].zichanjianzhisunshi,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].zichanjianzhisunshi,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].zichanjianzhisunshi,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].zichanjianzhisunshi,
          canshuxulie: 'zichanjianzhisunshi'
        },
        {
          message: '利润',
          coding: '区域经营利润',
          shuoming: '-',
          biaozhun: '-',
          hejiL: '-',
          hejiE: allrate.quyullirunAll || '',
          xinghao1: this.alllastlist[0].quyullirun || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].quyullirun,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].quyullirun,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].quyullirun,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].quyullirun,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].quyullirun,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].quyullirun,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].quyullirun,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].quyullirun,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].quyullirun,
          xinghao11:
            this.alllastlist[10] == null ? '' : this.alllastlist[10].quyullirun,
          xinghao12:
            this.alllastlist[11] == null ? '' : this.alllastlist[11].quyullirun,
          xinghao13:
            this.alllastlist[12] == null ? '' : this.alllastlist[12].quyullirun,
          xinghao14:
            this.alllastlist[13] == null ? '' : this.alllastlist[13].quyullirun,
          xinghao15:
            this.alllastlist[14] == null ? '' : this.alllastlist[14].quyullirun,
          xinghao16:
            this.alllastlist[15] == null ? '' : this.alllastlist[15].quyullirun,
          xinghao17:
            this.alllastlist[16] == null ? '' : this.alllastlist[16].quyullirun,
          xinghao18:
            this.alllastlist[17] == null ? '' : this.alllastlist[17].quyullirun,
          xinghao19:
            this.alllastlist[18] == null ? '' : this.alllastlist[18].quyullirun,
          xinghao20:
            this.alllastlist[19] == null ? '' : this.alllastlist[19].quyullirun,
          canshuxulie: 'quyullirun',
          //44
        },
        {
          message: '利润',
          coding: '利润率',
          shuoming: '-',
          biaozhun: '-',
          hejiL: '-',
          hejiE: allrate.quyulirunlvAll || '',
          xinghao1: this.alllastlist[0].quyulirunlv || '',
          xinghao2:
            this.alllastlist[1] == null ? '' : this.alllastlist[1].quyulirunlv,
          xinghao3:
            this.alllastlist[2] == null ? '' : this.alllastlist[2].quyulirunlv,
          xinghao4:
            this.alllastlist[3] == null ? '' : this.alllastlist[3].quyulirunlv,
          xinghao5:
            this.alllastlist[4] == null ? '' : this.alllastlist[4].quyulirunlv,
          xinghao6:
            this.alllastlist[5] == null ? '' : this.alllastlist[5].quyulirunlv,
          xinghao7:
            this.alllastlist[6] == null ? '' : this.alllastlist[6].quyulirunlv,
          xinghao8:
            this.alllastlist[7] == null ? '' : this.alllastlist[7].quyulirunlv,
          xinghao9:
            this.alllastlist[8] == null ? '' : this.alllastlist[8].quyulirunlv,
          xinghao10:
            this.alllastlist[9] == null ? '' : this.alllastlist[9].quyulirunlv,
          xinghao11:
            this.alllastlist[10] == null
              ? ''
              : this.alllastlist[10].quyulirunlv,
          xinghao12:
            this.alllastlist[11] == null
              ? ''
              : this.alllastlist[11].quyulirunlv,
          xinghao13:
            this.alllastlist[12] == null
              ? ''
              : this.alllastlist[12].quyulirunlv,
          xinghao14:
            this.alllastlist[13] == null
              ? ''
              : this.alllastlist[13].quyulirunlv,
          xinghao15:
            this.alllastlist[14] == null
              ? ''
              : this.alllastlist[14].quyulirunlv,
          xinghao16:
            this.alllastlist[15] == null
              ? ''
              : this.alllastlist[15].quyulirunlv,
          xinghao17:
            this.alllastlist[16] == null
              ? ''
              : this.alllastlist[16].quyulirunlv,
          xinghao18:
            this.alllastlist[17] == null
              ? ''
              : this.alllastlist[17].quyulirunlv,
          xinghao19:
            this.alllastlist[18] == null
              ? ''
              : this.alllastlist[18].quyulirunlv,
          xinghao20:
            this.alllastlist[19] == null
              ? ''
              : this.alllastlist[19].quyulirunlv,
          canshuxulie: 'quyulirunlv',
          //45
        },
      ]


      // console.log(this.tableData)
      this.ProMain.zhongduanchengjiaojia = allrate.zhongduanchengjiaojia
        ? parseFloat(allrate.zhongduanchengjiaojia).toFixed(2)
        : 0
      this.ProMain.zhuanyingshangmaolilv = allrate.zhuanyingshangmaolilv
        ? parseFloat(allrate.zhuanyingshangmaolilv).toFixed(2)
        : 0
      if (this.rateFormulaRenewXiangmucanshu != null) {
      }

      //加载产品总利率
      this.jiazaizonglilv(allrate)
      // 加载区域总利率
      this.jiazaiInterestRates(allrate)
      //比较毛利率
      this.shifoudadaoyinglimubiao()
    },
    // 加载区域总利率
    jiazaiInterestRates (q) {
      //存在总额
      if (q) {
        console.log(q.savenum, 'q.savenum')
        //遍历总额
        for (var c in q) {
          if (q[c] != null && q[c] != '') {
            //遍历表
            for (var ccc in this.regionData) {
              //若参数序列对应结果key
              if (this.regionData[ccc].canshuxulie == c) {
                //取平均值     onemoney单台一级供价  zhekoulv折扣率  wuliufeiyongdanweitiji单台体积  dantaianzhuangfei单台安装费

                this.divfangqy(c, 'onemoney', ccc, 'hejiE', q[c], q.savenum)
                this.divfangqy(c, 'zhekoulv', ccc, 'hejiE', q[c], q.savenum)
                this.divfangqy(c, 'zhekoulv', ccc, 'hejiL', q[c], q.savenum)

                //shenqingdanjia申请单价
                this.divfangqy(
                  c,
                  'shenqingdanjia',
                  ccc,
                  'hejiE',
                  q.dingdanjine,
                  q.productNum
                )

                //dantaichengben单台成本
                this.divfangqy(
                  c,
                  'dantaichengben',
                  ccc,
                  'hejiE',
                  q.maolichengbenheji,
                  q.productNum
                )

                //maolimaolilv材料毛利率
                this.divfangqy(
                  c,
                  'maolimaolilv',
                  ccc,
                  'hejiE',
                  q.maolimaoli,
                  q.buhanshuishouru
                )

                //jingyinggongxianlv经营贡献率
                this.divfangqy(
                  c,
                  'jingyinggongxianlv',
                  ccc,
                  'hejiE',
                  q.jingyinggongxiansan,
                  q.buhanshuishouru
                )

                //lirunlirunlv利润率
                this.divfangqy(
                  c,
                  'lirunlirunlv',
                  ccc,
                  'hejiE',
                  q.lirunsan,
                  q.buhanshuishouru
                )
              }
            }
          }
        }
      }
    },
    divfangqy (c, c1, ccc, heji, z, z1) {
      if (c == c1) {
        if (z != '' && z1 != '' && z != 0 && z1 != 0) {
          this.regionData[ccc][heji] = new big(parseFloat(z))
            .div(parseFloat(z1))
            .toString()
        } else {
          this.regionData[ccc][heji] = 0
        }
      }
    },
    //加载总利率
    jiazaizonglilv (q) {
      //存在总额
      if (q) {
        console.log(q.savenum, 'q.savenum')
        //遍历总额
        for (var c in q) {
          if (q[c] != null && q[c] != '') {
            //遍历表
            for (var ccc in this.tableData) {
              //若参数序列对应结果key
              if (this.tableData[ccc].canshuxulie == c) {
                //取平均值  zhongduanchengjiaojia中标成交价   zhuanyingshangmaolilv专营商毛利率   onemoney单台一级供价  zhekoulv折扣率  wuliufeiyongdanweitiji单台体积  dantaianzhuangfei单台安装费
                this.divfangfa(
                  c,
                  'zhongduanchengjiaojia',
                  ccc,
                  'hejiE',
                  q[c],
                  q.savenum
                )
                this.divfangfa(
                  c,
                  'zhuanyingshangmaolilv',
                  ccc,
                  'hejiE'.hejiE,
                  q[c],
                  q.savenum
                )
                this.divfangfa(c, 'onemoney', ccc, 'hejiE', q[c], q.savenum)
                this.divfangfa(c, 'zhekoulv', ccc, 'hejiE', q[c], q.savenum)
                this.divfangfa(c, 'zhekoulv', ccc, 'hejiL', q[c], q.savenum)
                this.divfangfa(
                  c,
                  'wuliufeiyongdanweitiji',
                  ccc,
                  'hejiE',
                  q[c],
                  q.savenum
                )
                this.divfangfa(
                  c,
                  'dantaianzhuangfei',
                  ccc,
                  'hejiE',
                  q[c],
                  q.savenum
                )

                //shenqingdanjia申请单价
                this.divfangfa(
                  c,
                  'shenqingdanjia',
                  ccc,
                  'hejiE',
                  q.dingdanjine,
                  q.productNum
                )

                //dantaichengben单台成本
                this.divfangfa(
                  c,
                  'dantaichengben',
                  ccc,
                  'hejiE',
                  q.maolichengbenheji,
                  q.productNum
                )

                //maolimaolilv材料毛利率
                this.divfangfa(
                  c,
                  'maolimaolilv',
                  ccc,
                  'hejiE',
                  q.maolimaoli,
                  q.buhanshuishouru
                )

                //jingyinggongxianlv经营贡献率
                this.divfangfa(
                  c,
                  'jingyinggongxianlv',
                  ccc,
                  'hejiE',
                  q.jingyinggongxiansan,
                  q.buhanshuishouru
                )

                //lirunlirunlv利润率
                this.divfangfa(
                  c,
                  'lirunlirunlv',
                  ccc,
                  'hejiE',
                  q.lirunsan,
                  q.buhanshuishouru
                )

                //盈利情况 材料毛利 合计率
                this.divfangfa(
                  c,
                  'yinglicailiaomaoli',
                  ccc,
                  'hejiL',
                  q.maolimaoli,
                  q.buhanshuishouru
                )

                //盈利情况 经营贡献 合计率
                this.divfangfa(
                  c,
                  'jingyinggongxian',
                  ccc,
                  'hejiL',
                  q.jingyinggongxiansan,
                  q.buhanshuishouru
                )

                //盈利情况 利润 合计率
                this.divfangfa(
                  c,
                  'yinglilirun',
                  ccc,
                  'hejiL',
                  q.lirunsan,
                  q.buhanshuishouru
                )
              }
            }
          }
        }
      }
    },

    divfangfa (c, c1, ccc, heji, z, z1) {
      if (c == c1) {
        if (z != '' && z1 != '' && z != 0 && z1 != 0) {
          this.tableData[ccc][heji] = new big(parseFloat(z))
            .div(parseFloat(z1))
            .toString()
        } else {
          this.tableData[ccc][heji] = 0
        }
      }
    },

    //判断是否达到盈利目标
    shifoudadaoyinglimubiao () {
      var mailizong = 0
      var maolibiao = 0
      var geshu = 0
      for (var g in this.alllastlist) {
        geshu++
        this.zongmaolilv += parseFloat(this.alllastlist[g].maolimaolilv)
        this.zongmaolilvbiao += parseFloat(
          this.alllastlist[g].sunyibiaocailiaomaolilv
        )
        this.jingyinggongxiangzong += parseFloat(
          this.alllastlist[g].jingyinggongxiansan
        )
        this.lirunzong += parseFloat(this.alllastlist[g].lirunsan)
      }
      mailizong = new big(this.zongmaolilv).div(geshu).toString()
      maolibiao = new big(this.zongmaolilvbiao).div(geshu).toString()
      this.zongmaolilvbiao = maolibiao
      this.zongmaolilv = parseInt((mailizong *= 100))
      console.log(this.zongmaolilvbiao, '总毛利率表值')
      console.log(this.zongmaolilv, '总毛利率值')

      if (
        this.tableData && this.tableData.length > 0
          ? this.tableData[45].hejiE == null || this.tableData[45].hejiE == ''
            ? false
            : true
          : false
      ) {
        if (this.tableData[45].hejiE >= 0.25) {
          this.xianshinage = 0
        } else {
          this.xianshinage = 1
        }
      }
    },
    jisuan (inputto, q) {
      //调接口回调方法
      ss.FormulaNew.getAllRateByChanPin(inputto).then((rd) => {
        console.log(rd, '看看回来的******************梁婕')

        this.jiazaijieguoxinxi(rd)
        // this.getSelectByArea(rd.result.salesregion)
        //若是提交的
        if (q == 3) {
          //如果提交成功且有被驳回版本
          if (rd.f == true && this.delrversion) {
            var id = {
              id: this.delrversion,
            }
            //把原被驳回版本删除
            ss.FormulaNew.luojishanchu(id).then((rd) => { })
          }
          this.$router.push({ path: '/personal/dealCenter' })
        }

        //项目号
        this.proid = rd.rateFormulaRenewXiangmucanshu.proid

        this.chazhaocesuan(rd.rateFormulaRenewXiangmucanshu.proid)

        //项目名称
        this.ProMain.projectName = rd.result.projectName
        //项目描述
        this.ProMain.projectDescription = rd.result.projectDescription

        //质保年限
        this.ProMain.warrantyPeriod = rd.result.warrantyPeriod

        //收货单位
        this.ProMain.toCompanyname = rd.result.toCompanyname

        //是否改制
        this.ProMain.isReform = rd.result.isReform

        if (this.ProMain.isReform && this.ProMain.isReform == '1') {
          this.reformFlag = true
        }

        // //专营商毛利率
        // this.ProMain.zhuanyingshangmaolilv = rd.result.zhuanyingshangmaolilv;
        //下部列表所有计算查询返回信息
        var listrd = rd.marnesList
        var allrate = rd.allrate
        var rateFormulaRenewAreaList = rd.rateFormulaRenewAreaList || []
        //返回计算版本
        this.rateFormulaRenewVer = rd.rateFormulaRenewVer
        //从原始记录版本中回调回来的上部内容
        this.rateFormulaRenewXiangmucanshu = rd.rateFormulaRenewXiangmucanshu
        //开标时间
        this.ProMain.bid =
          rd.rateFormulaRenewXiangmucanshu.bid != null &&
            rd.rateFormulaRenewXiangmucanshu.bid != '' &&
            rd.rateFormulaRenewXiangmucanshu.bid != '0' &&
            rd.rateFormulaRenewXiangmucanshu.bid != 0
            ? this.$util.riQi(rd.rateFormulaRenewXiangmucanshu.bid)
            : null
        this.ProMain.bidway = rd.rateFormulaRenewXiangmucanshu.bidway
        this.repairtype = rd.rateFormulaRenewXiangmucanshu.baoxiuqi
        this.ProMain.pdpay = rd.rateFormulaRenewXiangmucanshu.f28
        this.ProMain.fdpay = rd.rateFormulaRenewXiangmucanshu.f6
        this.ProMain.mdpay = rd.rateFormulaRenewXiangmucanshu.f27
        this.ProMain.ldpay = rd.rateFormulaRenewXiangmucanshu.f34
        this.ProMain.fdpayday = rd.rateFormulaRenewXiangmucanshu.f23
        this.ProMain.mdpayday = rd.rateFormulaRenewXiangmucanshu.f13
        this.ProMain.ldpayday = rd.rateFormulaRenewXiangmucanshu.f30
        this.ProMain.youxiaoqi = [
          rd.rateFormulaRenewXiangmucanshu.youxiaoqistart || '',
          rd.rateFormulaRenewXiangmucanshu.youxiaoqi || '',
        ]

        //送达城市代码
        this.ProMain.songdachengshi = rd.rateFormulaRenewXiangmucanshu
          .songdachengshi
          ? rd.rateFormulaRenewXiangmucanshu.songdachengshi
          : ''

        //送达地址
        this.ProMain.songdadizhi = rd.rateFormulaRenewXiangmucanshu.songdadizhi
          ? rd.rateFormulaRenewXiangmucanshu.songdadizhi
          : ''

        if (!this.ProMain.songdachengshi || this.ProMain.songdachengshi == '') {
          //送达城市
          this.ProMain.songdachengshi = rd.result.receivingCity
        }
        if (!this.ProMain.songdadizhi || this.ProMain.songdadizhi == '') {
          //送达地址
          this.ProMain.songdadizhi = rd.result.receivingAddress
        }

        if (
          rd.rateFormulaRenewXiangmucanshu.shiyongren != null &&
          rd.rateFormulaRenewXiangmucanshu.shiyongren != ''
        ) {
          this.ProMain.shiyongren = rd.rateFormulaRenewXiangmucanshu.shiyongren //使用人usercode
        }

        if (
          rd.rateFormulaRenewXiangmucanshu.xuanzhongren != null &&
          rd.rateFormulaRenewXiangmucanshu.xuanzhongren != ''
        ) {
          this.ProMain.xuanzhongren =
            rd.rateFormulaRenewXiangmucanshu.xuanzhongren //使用人username
        }

        console.log(rd.rateFormulaRenewXiangmucanshu, '看看回调')
        //保存计算返回版本id
        if (rd.rateFormulaRenewVer.rversion) {
          this.fanhuibanbenid = rd.rateFormulaRenewVer.rversion
        }
        console.log(allrate)
        this.allratemap = rd.allrate
        //如果是驳回跳转的
        if (rd.shenpijindu) {
          //被驳回版本id
          this.delrversion = rd.delrversion
          //审批意见
          this.ProMain.shenpiyijian = rd.shenpijindu[2] || ''
          //显示审批意见
          this.shenpiyijianshow = true

          this.bohuitijiao = true

          this.shoucijiaohu = false

          var rversion = {
            rversion: this.rversion,
          }

          //查找财务单保存
          this.chazhaocaiwudanbaocun(rversion)
        }
        // 获取区域费用信息
        ss.noticeBoard.getSelectByAreaCode({
          areaCode: rd.result.salesregion
        }).then(rd => {
          if (rd.obj) {
            this.regionChack = true
          }
          this.regionalFees = rd.obj
          this.addbiaotilie(listrd, allrate, rateFormulaRenewAreaList)
        })
        //加载列
        this.shoucijiaohu = false
      })
    },
    // 获取区域费率
    getSelectByArea (code) {

    },

    panduanxiaoshu (q) {
      var d = true

      var m = true

      for (var c in this.ProMain) {
        if (d == true) {
          if (c == 'pdpay' || c == 'fdpay' || c == 'mdpay' || c == 'ldpay') {
            if (
              c == 'pdpay' &&
              (this.ProMain[c] >= 1 ||
                parseFloat(this.ProMain[c]) >= 1 ||
                parseInt(this.ProMain[c]) >= 1)
            ) {
              d = true
              m = false
            } else {
              if (m == true) {
                if (
                  parseFloat(this.ProMain[c]) != 0 &&
                  /^0.\d+$/.test(this.ProMain[c]) == false
                ) {
                  if (q != 0) {
                    this.$msg.msge('百分比请输入小于1的小数')
                  }

                  d = false
                } else {
                  d = true
                }
              }
            }
          }
        }
      }

      // if (d == true) {
      //
      //     if (this.ProMain.pdpay >= 1 || parseFloat(this.ProMain.pdpay) >= 1.0 || parseInt(this.ProMain.pdpay) >= 1) {
      //
      //         this.$msg.msge("请输入小于1的小数")
      //
      //         this.ProMain.pdpay = 1;
      //         this.ProMain.fdpay = 0;
      //         this.ProMain.mdpay = 0;
      //         this.ProMain.ldpay = 0;
      //
      //     } else {
      //
      //         if ((parseFloat(this.ProMain.pdpay) + parseFloat(this.ProMain.fdpay) + parseFloat(this.ProMain.mdpay) + parseFloat(this.ProMain.ldpay)) != 1) {
      //
      //             d = false;
      //
      //             if (q != 0) {
      //
      //                 this.$msg.msge("四个百分值小数相加必须等于100%")
      //
      //             }
      //
      //         }
      //
      //
      //     }
      //
      // }

      return d
    },

    //前后台交互
    getconfigs (q) {
      if (
        q != 0 &&
        !(
          this.ProMain.youxiaoqi &&
          this.ProMain.youxiaoqi[0] != '' &&
          this.ProMain.youxiaoqi[0] != null &&
          this.ProMain.youxiaoqi[1] != '' &&
          this.ProMain.youxiaoqi[1] != null &&
          this.ProMain.bid &&
          this.ProMain.bidway &&
          this.ProMain.pdpay != null &&
          this.ProMain.fdpay != null &&
          this.ProMain.mdpay != null &&
          this.ProMain.ldpay != null &&
          this.ProMain.fdpayday != null &&
          this.ProMain.mdpayday != null &&
          this.ProMain.ldpayday != null
        )
      ) {
        this.$msg.msge('请先填写完整信息')
      } else {
        // 记录当前是否计算
        if (q == 1) {
          this.isCount = true
          console.log('是否进入判断并更改1111111111111', this.isCount)
        }
        this.dierceng(q)
      }
    },

    dierceng (q) {
      var d = this.panduanxiaoshu(q)

      if (
        q != 0 &&
        (!this.ProMain.songdachengshi || !this.ProMain.songdadizhi)
      ) {
        this.$msg.msge('请先补充送达信息')
      } else {
        if (q != 0 && d == false) {
        } else {
          this.jinxingjiaohu(q)
        }
      }
    },

    //去交互
    jinxingjiaohu (q) {
      console.log(this.shoucijiaohu, 'this.shoucijiaohu')
      console.log(this.tableData, 'this.tableData')

      //计算前清空上次的计算过程
      this.rateFormulaRenewVer = {}
      this.xianshinage = 9
      this.jingyinggongxiangzong = 0
      this.lirunzong = 0
      this.zongmaolilvbiao = 0
      this.zongmaolilv = 0
      var s17s14s3s12 = []
      if (!this.shoucijiaohu) {
        console.log(this.tableData[0].xinghao1, '看看编码')
        for (var c = 1; c < 20; c++) {
          s17s14s3s12.push({
            proProductInfoId: this.tableData[0]['id' + c],
            marcode: this.tableData[0]['xinghao' + c],
            s17: this.tableData[9]['xinghao' + c],
            s14: this.tableData[21]['xinghao' + c],
            s3: this.tableData[30]['xinghao' + c],
            s12: this.tableData[4]['xinghao' + c],
          })
        }
      }
      var jiacan = []
      for (var g in this.xiangmuchanpinlist) {
        var dd = {
          proProductInfoId: this.xiangmuchanpinlist[g].id,
          marcode: this.xiangmuchanpinlist[g].productId,
          s17: '0',
          s14: '0',
          s3: '0',
          s12: '0',
        }
        jiacan.push(dd)
      }
      console.log(jiacan, '看看jiacan')
      //区域加参
      let rateFormulaRenewAreaList = []
      if (this.alllastlist.length > 0) {
        rateFormulaRenewAreaList = this.alllastlist.map(item => {
          return {
            productld: item.marcode || '',//产品编码
            rengongchengben: item.rengongchengben || 0,//人工成本
            zuzhiyunyingfei: item.zuzhiyunyingfei || 0,//组织运营费
            yingxiaofei: item.yingxiaofei || 0,//营销费用
            wuliufei: item.wuliufei || 0,//物流费用
            shouhoufei: item.shouhoufei || 0,//售后费用
            shuifei: item.shuifei || 0,//税费
            zichanjianzhisunshi: item.zichanjianzhisunshi || 0,//资产减值损失
            quyullirun: item.quyullirun || 0,//区域经营利润
            quyulirunlv: item.quyulirunlv || 0,//区域经营利润率
          }
        })
      }
      console.log(rateFormulaRenewAreaList, '区域信息')

      //后台接口入参
      var inputto = {
        islengku: '0',
        shiyongren: q == 0 ? '' : this.ProMain.shiyongren, //使用人usercode

        xuanzhongren: q == 0 ? '' : this.ProMain.xuanzhongren, //使用人username

        proid: this.proid,
        // "s17": "1500",
        // "s12": "2000",
        f28: q == 0 ? '' : this.ProMain.pdpay + '',
        f6: q == 0 ? '' : this.ProMain.fdpay + '',
        f23: q == 0 ? '' : this.ProMain.fdpayday + '',
        f27: q == 0 ? '' : this.ProMain.mdpay + '',
        f13: q == 0 ? '' : this.ProMain.mdpayday + '',
        f34: q == 0 ? '' : this.ProMain.ldpay + '',
        f30: q == 0 ? '' : this.ProMain.ldpayday + '',
        songdachengshi: q == 0 ? '' : this.ProMain.songdachengshi,
        songdadizhi: q == 0 ? '' : this.ProMain.songdadizhi,
        baoxiuqi: q == 0 ? '' : this.repairtype + '',
        // "s14": "10",
        // "s3": "2",
        bid: q == 0 ? '' : this.ProMain.bid,
        bidway: q == 0 ? '' : this.ProMain.bidway + '',
        s17s14s3s12: q == 0 ? jiacan : s17s14s3s12,
        savestatus: q == 2 ? 0 : q == 3 ? 1 : null, //2暂存 对应传后台0   3提交 对应传后台1  不是就null
        rversion: this.shoucijiaohu
          ? this.rversion == null
            ? null
            : this.rversion
          : null, //计算版本
        xid:
          this.fanhuibanbenid == null
            ? this.rversion == null
              ? this.fanhuibanbenid
              : this.rversion
            : this.fanhuibanbenid, //之前的保存过的返回计算版本id
        isReform: this.ProMain.isReform,
        warrantyPeriod: this.ProMain.warrantyPeriod,
        rateFormulaRenewAreaList: rateFormulaRenewAreaList
      }
      if (
        q != 0 &&
        this.ProMain.youxiaoqi != null &&
        this.ProMain.youxiaoqi[0] != null &&
        this.ProMain.youxiaoqi[0] != '' &&
        this.ProMain.youxiaoqi[0] != 'NaN-NaN-NaN' &&
        this.ProMain.youxiaoqi[1] != null &&
        this.ProMain.youxiaoqi[1] != '' &&
        this.ProMain.youxiaoqi[1] != 'NaN-NaN-NaN'
      ) {
        console.log(this.ProMain.youxiaoqi[0], 'this.ProMain.youxiaoqi[0]')
        console.log(this.ProMain.youxiaoqi[1], 'this.ProMain.youxiaoqi[1]')
        inputto.youxiaoqistart = this.$util.riQi(this.ProMain.youxiaoqi[0])
        inputto.youxiaoqi = this.$util.riQi(this.ProMain.youxiaoqi[1])
      }

      console.log(this.rversion, '传了没')
      this.jisuan(inputto, q)
    },
  },
}
</script>

<style scoped lang="scss">
.zancun {
  background-color: #24b5b8;
  color: white;
}

.h-piece,
.h-table {
  margin: 20px;
  background: #fff;
  padding: 20px;
}
::v-deep .el-table {
  border-bottom: none;
}
::v-deep .el-table tbody td:first-child {
  border-left: none;
}
::v-deep.el-table tbody td,
.el-table tbody .el-table__cell {
  border-right: 1px solid #ebeef5;
}
</style>
<style scoped lang="scss">
$ft-colorg: #21d16f; //绿色的字
$ft-coloro: #e79118; //黄色的字
$bg-colorg: #f6fffa; //绿色的背景色
$bg-coloro: #fffbf7; //黄色的背景色
$bg-colorb: #3b77fc; //蓝色
$bg-colorgrey: #c3c3c3; //灰色
.yx_progressBar {
  width: 100%;
  border: 1px solid $ft-colorg;
  background-color: $bg-colorg;
  padding: 0.38rem;
  position: relative;

  .yxExtra {
    position: absolute;
    color: $ft-colorg;
    top: 0.3rem;
    font-size: 0.18rem;
    right: 0.3rem;
  }

  .yx_topTip {
    display: flex;
    justify-content: flex-start;
    color: #424441;
    font-size: 0.18rem;

    .leftdes {
      margin-right: 0.75rem;
    }

    .percent {
      color: $ft-colorg;
    }
  }

  .con_progress {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 0.3rem;

    .eve_proout {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      &:last-child .line_pro {
        display: none;
      }

      .eve_pro {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        position: relative;
        background-color: $bg-colorgrey;

        .persons {
          position: absolute;
          top: 20px;
          min-width: 1.8rem;
          text-align: center;
          margin-left: -0.75rem;
          margin-top: 0.04rem;
          font-size: 0.18rem;
        }

        .personsAc {
          color: $bg-colorb;
        }
      }

      .line_pro {
        width: 3rem;
        height: 4px;
        background-color: $bg-colorgrey;
      }

      // 激活
      .eve_proAc {
        background-color: $bg-colorb;
      }

      .line_proAc {
        width: 3rem;
        height: 4px;
        background-color: $bg-colorb;
      }

      .eve_proAcpass {
        background-color: $bg-colorgrey;
      }

      .line_proAcpass {
        width: 3rem;
        height: 4px;
        background-color: $bg-colorb;
      }
    }
  }
}

.yx_progressBarAc {
  border: 1px solid $ft-coloro;
  background-color: $bg-coloro;

  .yxExtra {
    color: $ft-coloro;
  }

  .yx_topTip {
    .percent {
      color: $ft-coloro;
    }
  }
}

.xia {
  display: flex;
  justify-content: center;
  margin-top: 0.7rem;
}
</style>

<style>
.el-table .hidden-row {
  display: none;
}

.h-enter .h-formbLine .h-elformWrap-1.ljjrange .el-form-item__label {
  width: 12.5%;
}

.h-enter .h-formbLine .h-elformWrap-1.ljjrange .el-form-item__content {
  width: 87.5%;
}

.h-enter .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
}

.h-enter .h-formbLine .el-form-item__label {
  width: 43%;
}

.h-enter .h-formbLine .el-form-item__content {
  width: 57%;
}

.ljjrange .el-range-editor .el-range-separator {
  line-height: 18px;
}
.ljjtableenterthree .h-tableInput .el-input__inner {
  padding: 0.05rem 0.1rem;
}
.ljjtableenterthree .h-tableInput .el-input__icon {
  line-height: 0.25rem;
}
</style>
